import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, BarChart3, Copy, Bot,Cpu, Loader2, HelpCircle,Share2, Mail, MessageCircle,Microchip,Brain } from 'lucide-react';
import TooltipPortal from '../components/TooltipPortal';
import api from '../services/api';
import { getSpecializationConfigs, getEnhancedSpecializationMatch } from '../config/fundConfigurations';
import { getDisplayName } from '../config/fundNamesConfig';
import AdvancedAIAnimation from './AdvancedAIAnimation';
import  LeadModal  from './FloatingElements'; // 🆕 הוסף את השורה הזו
import html2canvas from 'html2canvas';
import ReturnsSection from './ReturnsSection';
import { createRoot } from 'react-dom/client';

const FundComparisonComponent = ({ 
  category = 'study-funds', 
  currentProductId = null,
  currentProduct = null,
  className = "" ,
  lastUpdated = null,
  matchingSpecialization = null,
    onOpenLeadModal = null, // 🆕 הוסף את זה
}) => {
  const [availableFunds, setAvailableFunds] = useState([]);
  const [selectedFundId, setSelectedFundId] = useState('');
  const [selectedFund, setSelectedFund] = useState(null);
  const [currentFundId, setCurrentFundId] = useState(currentProductId);
  const [currentFundData, setCurrentFundData] = useState(currentProduct);
  const [currentFundFee, setCurrentFundFee] = useState('');
  const [selectedFundFee, setSelectedFundFee] = useState('');
  const [smartAnalysis, setSmartAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [analyzingAI, setAnalyzingAI] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');
const [showLeadModal, setShowLeadModal] = useState(false);
const [leadModalContext, setLeadModalContext] = useState(null);
// 🆕 State חדש - הוסף אחרי ה-states הקיימים
const [currentFundSearchMode, setCurrentFundSearchMode] = useState(false);
const [selectedFundSearchMode, setSelectedFundSearchMode] = useState(false);
const [currentFundSearch, setCurrentFundSearch] = useState('');
const [selectedFundSearch, setSelectedFundSearch] = useState('');
const [currentFundSearchResults, setCurrentFundSearchResults] = useState([]);
const [selectedFundSearchResults, setSelectedFundSearchResults] = useState([]);
const [showCurrentFundResults, setShowCurrentFundResults] = useState(false);
const [showSelectedFundResults, setShowSelectedFundResults] = useState(false);
const [currentFundDepositFee, setCurrentFundDepositFee] = useState('');
const [selectedFundDepositFee, setSelectedFundDepositFee] = useState('');

const [shareMessage, setShareMessage] = useState('');
const [showShareOptions, setShowShareOptions] = useState(false);
const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const analysisRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const formatDataDate = () => {
    const now = new Date();
    const year = now.getFullYear().toString().slice(-2); // שנתיים אחרונות
    const month = String(now.getMonth() + 1).padStart(2, '0'); // חודש נוכחי עם אפס מוביל
    return `${month}/${year}`;
  };
  useEffect(() => {
    if (currentProduct && category) {
      loadAvailableFunds();
    }
  }, [currentProduct, category]);
useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth < 768);
  };
  
  checkMobile();
  window.addEventListener('resize', checkMobile);
  
  return () => window.removeEventListener('resize', checkMobile);
}, []); // <- הוסף dependency array ריק

const isPensionFund = () => {
  return category === 'pension-plans' ;
};

const handleOpenLeadModal = (context) => {
  setLeadModalContext(context);
  setShowLeadModal(true);
};
const findCurrentSpecialization = () => {
    // אם קיבלנו התמחות מ-ProductPage - השתמש בה
    if (matchingSpecialization) {
      return matchingSpecialization;
    }
    
    // אחרת - השתמש בלוגיקה הקיימת
    const specializations = getSpecializationConfigs(category);
    const currentId = parseInt(currentProductId);
    
    return specializations.find(spec => 
      spec.fundIds.includes(currentId)
    ) || specializations[0];
  };
// 🆕 חיפוש קרנות דומות לפי classification ו-riskLevel
const searchSimilarFunds = async (searchTerm) => {
  if (!searchTerm || searchTerm.length < 2 || !currentFundData) return [];
  
  try {
    const currentClassification = currentFundData.classification;
    const currentRiskLevel = currentFundData.riskLevel?.level;
    
    // 🐛 הוספת דיבוג לבדיקת הנתונים
    // console.log('🔍 Current fund search criteria:', {
    //   classification: currentClassification,
    //   riskLevel: currentRiskLevel,
    //   searchTerm: searchTerm
    // });
    
    // חיפוש בכל הקרנות באותה קטגוריה
    const allFunds = await api.getProducts(category, { limit: 1000 });
    // console.log('📊 Total funds received:', allFunds.length);
    
    // 🎯 סינון לפי classification ו-riskLevel עם דיבוג
    const similarFunds = allFunds.filter(fund => {
      const matchesClassification = fund.classification === currentClassification;
      const matchesRiskLevel = fund.riskLevel?.level === currentRiskLevel;
      
      // דיבוג מפורט לכמה קרנות ראשונות
      // if (allFunds.indexOf(fund) < 5) {
      //   console.log(`🔍 Fund ${fund.id} (${fund.name}):`, {
      //     classification: fund.classification,
      //     riskLevel: fund.riskLevel?.level,
      //     matchesClassification,
      //     matchesRiskLevel
      //   });
      // }
      
      return matchesClassification && matchesRiskLevel;
    });
    
    // console.log('✅ Similar funds after filtering:', similarFunds.length);
    
    // 🔎 חיפוש לפי מילה או מזהה
    const searchResults = similarFunds.filter(fund => {
      const searchLower = searchTerm.toLowerCase();
      const nameMatch = fund.name.toLowerCase().includes(searchLower);
      const companyMatch = fund.company.toLowerCase().includes(searchLower);
      const idMatch = fund.id.toString().includes(searchTerm);
      
      return nameMatch || companyMatch || idMatch;
    });
    
    // console.log('🎯 Final search results:', searchResults.length);
    
    // מיון לפי תשואה
    return searchResults.sort((a, b) => (b.returns?.year1 || 0) - (a.returns?.year1 || 0));
    
  } catch (error) {
    console.error('❌ Error searching similar funds:', error);
    return [];
  }
};
 const TooltipContent = ({ isMobile = false, onClose }) => (
    <div className={`relative ${isMobile ? 'bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4 border border-blue-200' : ''}`}>
      {/* כפתור סגירה */}
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-2 left-2 text-gray-500 hover:text-red-500 transition-colors text-lg font-bold leading-none w-6 h-6 flex items-center justify-center rounded-full hover:bg-red-50"
          aria-label="סגור"
        >
          ×
        </button>
      )}
      
      <h4 className={`font-semibold mb-3 ${isMobile ? 'text-blue-800' : 'text-white'}`}>
        📊 מה זה השוואה חכמה?
      </h4>
      
      <div className={`space-y-3 ${isMobile ? 'text-gray-700' : 'text-gray-300'}`}>
        <p className="text-sm">
          השוואה מהירה וממוקדת בין שתי קופות / קרנות / פוליסות – בתשואה מצטברת, לכל תקופות ההשקעה מ-12 חודשים ועד 5 שנים.
        </p>
        
        <p className="text-sm">
          ניתוח ברור ומהיר של מי הובילה, מתי, ומהי עקביות הביצועים של כל קופה במסלול המקביל ברמת הסיכון.
        </p>
        
        <div className={`${isMobile ? 'bg-blue-100' : 'bg-gray-800'} rounded-lg p-3 text-xs`}>
          <div className={`font-bold mb-2 ${isMobile ? 'text-blue-800' : 'text-blue-300'}`}>
            💡 מה מקבלים:
          </div>
          <ul className={`space-y-1 ${isMobile ? 'text-blue-700' : 'text-gray-300'}`}>
            <li>• השוואה מפורטת לכל תקופה</li>
            <li>• ניתוח דמי ניהול</li>
            <li>• המלצות AI מותאמות אישית</li>
            <li>• דוח מלא לעתקה והדפסה</li>
          </ul>
        </div>
      </div>
    </div>
  );
// 🔧 גרסה אלטרנטיבית - סינון רק לפי classification אם יש בעיה ברמת סיכון
const searchSimilarFundsAlternative = async (searchTerm) => {
  if (!searchTerm || searchTerm.length < 2 || !currentFundData) return [];
  
  try {
    const currentClassification = currentFundData.classification;
    const currentRiskLevel = currentFundData.riskLevel?.level;
    
    // חיפוש בכל הקרנות באותה קטגוריה
    const allFunds = await api.getProducts(category, { limit: 1000 });
    
    // סינון בשלבים
    let filteredFunds = allFunds;
    
    // שלב 1: סינון לפי classification
    if (currentClassification) {
      filteredFunds = filteredFunds.filter(fund => 
        fund.classification === currentClassification
      );
    }
    
    // שלב 2: סינון לפי riskLevel (רק אם קיים)
    if (currentRiskLevel !== undefined && currentRiskLevel !== null) {
      const riskFilteredFunds = filteredFunds.filter(fund => 
        fund.riskLevel?.level === currentRiskLevel
      );
      
      // אם יש תוצאות עם רמת סיכון זהה - השתמש בהן
      // אחרת, השאר רק עם classification
      if (riskFilteredFunds.length > 0) {
        filteredFunds = riskFilteredFunds;
      }
    }
    
    // חיפוש לפי מילה או מזהה
    const searchResults = filteredFunds.filter(fund => {
      const searchLower = searchTerm.toLowerCase();
      return (
        fund.name.toLowerCase().includes(searchLower) ||
        fund.company.toLowerCase().includes(searchLower) ||
        fund.id.toString().includes(searchTerm)
      );
    });
    
    // מיון לפי תשואה
    return searchResults.sort((a, b) => (b.returns?.year1 || 0) - (a.returns?.year1 || 0));
    
  } catch (error) {
    console.error('Error searching similar funds:', error);
    return [];
  }
};






  const handleSwapFunds = () => {
    if (!selectedFundId || loading) return;
    
    // שמירת הערכים הנוכחיים
    const tempCurrentId = currentFundId;
    const tempCurrentData = currentFundData;
    const tempCurrentFee = currentFundFee;
    
    const tempSelectedId = selectedFundId;
    const tempSelectedData = selectedFund;
    const tempSelectedFee = selectedFundFee;
    
    // החלפת הקרנות
    setCurrentFundId(tempSelectedId);
    setCurrentFundData(tempSelectedData);
    setCurrentFundFee(tempSelectedFee);
    
    setSelectedFundId(tempCurrentId);
    setSelectedFund(tempCurrentData);
    setSelectedFundFee(tempCurrentFee);
    
    // איפוס הניתוח
    setSmartAnalysis(null);
  };
useEffect(() => {
  const handleClickOutside = (event) => {
    if (!event.target.closest('.relative')) {
      setShowCurrentFundResults(false);
      setShowSelectedFundResults(false);
    }
  };

  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);
  const loadAvailableFunds = async () => {
    try {
      const currentSpec = findCurrentSpecialization();
      if (!currentSpec) return;

      const allFunds = await api.getProducts(category);
      const fundsInSpec = allFunds.filter(fund => 
        currentSpec.fundIds.includes(parseInt(fund.id))
      );

      setAvailableFunds(fundsInSpec);
    } catch (error) {
      console.error('Error loading available funds:', error);
    }
  };
// 🆕 פונקציות חדשות - הוסף לפני ה-render
const toggleCurrentFundSearchMode = () => {
  setCurrentFundSearchMode(!currentFundSearchMode);
  if (currentFundSearchMode) {
    setCurrentFundSearch('');
    setShowCurrentFundResults(false);
  }
};

const toggleSelectedFundSearchMode = () => {
  setSelectedFundSearchMode(!selectedFundSearchMode);
  if (selectedFundSearchMode) {
    setSelectedFundSearch('');
    setShowSelectedFundResults(false);
  }
};

const handleCurrentFundSearch = async (searchTerm) => {
  setCurrentFundSearch(searchTerm);
  if (searchTerm.length >= 2) {
    const results = await searchSimilarFunds(searchTerm);
    setCurrentFundSearchResults(results.slice(0, 10));
    setShowCurrentFundResults(true);
  } else {
    setCurrentFundSearchResults([]);
    setShowCurrentFundResults(false);
  }
};

const handleSelectedFundSearch = async (searchTerm) => {
  setSelectedFundSearch(searchTerm);
  if (searchTerm.length >= 2) {
    const results = await searchSimilarFunds(searchTerm);
    const filteredResults = results.filter(fund => fund.id !== currentFundId);
    setSelectedFundSearchResults(filteredResults.slice(0, 10));
    setShowSelectedFundResults(true);
  } else {
    setSelectedFundSearchResults([]);
    setShowSelectedFundResults(false);
  }
};

const selectCurrentFundFromSearch = async (fund) => {
  setCurrentFundId(fund.id);
  setCurrentFundData(fund);
  setCurrentFundSearch('');
  setShowCurrentFundResults(false);
  setSmartAnalysis(null);
  
  // חזור למצב רשימה
  setCurrentFundSearchMode(false);
  
  // הוסף לרשימה אם לא קיים
  const isInAvailableFunds = availableFunds.some(availableFund => availableFund.id === fund.id);
  if (!isInAvailableFunds) {
    setAvailableFunds(prev => [fund, ...prev]);
  }
};



const selectSelectedFundFromSearch = async (fund) => {
  setSelectedFundId(fund.id);
  setSelectedFund(fund);
  setSelectedFundSearch('');
  setShowSelectedFundResults(false);
  setSmartAnalysis(null);
  
  // חזור למצב רשימה
  setSelectedFundSearchMode(false);
  
  // הוסף לרשימה אם לא קיים
  const isInAvailableFunds = availableFunds.some(availableFund => availableFund.id === fund.id);
  if (!isInAvailableFunds) {
    setAvailableFunds(prev => [fund, ...prev]);
  }
};
  const handleFundSelection = async (fundId) => {
    if (!fundId) {
      setSelectedFund(null);
      setSmartAnalysis(null);
      return;
    }

    setLoading(true);
    try {
      const fund = await api.getProductById(fundId, category);
      setSelectedFund(fund);
      setSmartAnalysis(null);
    } catch (error) {
      console.error('Error loading selected fund:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCurrentFundChange = async (fundId) => {
    if (!fundId) return;
    
    setLoading(true);
    try {
      const fund = await api.getProductById(fundId, category);
      setCurrentFundData(fund);
      setCurrentFundId(fundId);
      setSmartAnalysis(null);
    } catch (error) {
      console.error('Error loading current fund:', error);
    } finally {
      setLoading(false);
    }
  };

const handleSmartAnalysis = async () => {
    if (!selectedFund) return;

    setAnalyzingAI(true);
    
    // סימולציה של זמן עיבוד AI
    await new Promise(resolve => setTimeout(resolve, 3500));

    const periods = [
      { key: 'year1', label: '12 חודשים אחרונים', years: 1 },
      { key: 'year2', label: '2 שנים אחרונות', years: 2 },
      { key: 'year3', label: '3 שנים אחרונות', years: 3 },
      { key: 'year4', label: '4 שנים אחרונות', years: 4 },
      { key: 'year5', label: '5 שנים אחרונות', years: 5 }
    ];

    let currentFundWins = 0;
    let selectedFundWins = 0;
    const performanceComparison = [];

    periods.forEach(period => {
      const currentReturn = currentFundData.returns?.[period.key];
      const selectedReturn = selectedFund.returns?.[period.key];

      if (currentReturn !== null && selectedReturn !== null && !isNaN(currentReturn) && !isNaN(selectedReturn)) {
        const currentWins = currentReturn > selectedReturn;
        if (currentWins) {
          currentFundWins++;
        } else {
          selectedFundWins++;
        }

        // 🆕 הוספת ממוצעים שנתיים לנתוני ההשוואה
        const getAnnualAverage = (fundData, periodKey) => {
          switch(periodKey) {
            case 'year2': return fundData.returns?.avgAnnual2Years;
            case 'year3': return fundData.returns?.avgAnnual3Years;
            case 'year4': return fundData.returns?.avgAnnual4Years;
            case 'year5': return fundData.returns?.avgAnnual5Years;
            default: return null;
          }
        };

        performanceComparison.push({
          period: period.label,
          key: period.key, // 🆕 הוספנו את המפתח
          years: period.years,
          currentReturn: currentReturn.toFixed(2),
          selectedReturn: selectedReturn.toFixed(2),
          currentWins,
          difference: (currentReturn - selectedReturn).toFixed(2),
          // 🆕 ממוצעים שנתיים
          currentAnnualAvg: getAnnualAverage(currentFundData, period.key),
          selectedAnnualAvg: getAnnualAverage(selectedFund, period.key)
        });
      }
    });

    // שאר הקוד נשאר זהה...
    let feeComparison = null;
    if (currentFundFee && selectedFundFee) {
      const currentFee = parseFloat(currentFundFee);
      const inputFee = parseFloat(selectedFundFee);
      
      feeComparison = {
        currentFee: currentFee.toFixed(2),
        selectedFee: inputFee.toFixed(2),
        currentHasAdvantage: currentFee < inputFee,
        isEqual: Math.abs(currentFee - inputFee) < 0.01,
        difference: Math.abs(currentFee - inputFee).toFixed(2)
      };
    }
let depositFeeComparison = null;
if (isPensionFund() && currentFundDepositFee && selectedFundDepositFee) {
  const currentDepositFee = parseFloat(currentFundDepositFee);
  const selectedDepositFee = parseFloat(selectedFundDepositFee);
  
  depositFeeComparison = {
    currentDepositFee: currentDepositFee.toFixed(2),
    selectedDepositFee: selectedDepositFee.toFixed(2),
    currentHasAdvantage: currentDepositFee < selectedDepositFee,
    isEqual: Math.abs(currentDepositFee - selectedDepositFee) < 0.01,
    difference: Math.abs(currentDepositFee - selectedDepositFee).toFixed(2)
  };
}
    const currentFundName = getDisplayName(currentFundData);
    const selectedFundName = getDisplayName(selectedFund);

    const actualWinner = currentFundWins > selectedFundWins ? 'current' : 
                        selectedFundWins > currentFundWins ? 'selected' : 'tie';

const newAnalysis = {
  currentFundName,
  selectedFundName,
  currentFundWins,
  selectedFundWins,
  totalPeriods: performanceComparison.length,
  performanceComparison,
  feeComparison,
  depositFeeComparison,
  actualWinner,
  recommendation: generateRecommendation(
    currentFundWins, 
    selectedFundWins, 
    performanceComparison.length, 
    currentFundName, 
    selectedFundName, 
    feeComparison, 
    depositFeeComparison,
    currentFundData, // 🆕 הוספנו את זה
    selectedFund     // 🆕 הוספנו את זה
  )
};

    setSmartAnalysis(newAnalysis);
    setAnalyzingAI(false);
     setTimeout(() => {
        const analysisTitle = document.querySelector('.ai-analysis-title');
        if (analysisTitle) {
            const elementPosition = analysisTitle.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 70 // רווח מהחלק העליון
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }, 500);
  };

// 🔧 תקן את הפונקציה generateRecommendation:
const generateRecommendation = (currentWins, selectedWins, totalPeriods, currentFundName, selectedFundName, feeComparison, depositFeeComparison, currentFundData, selectedFund) => {
  let dynamicPart = '';
  
  if (currentWins > selectedWins) {
    dynamicPart = `הקרן ב${currentFundName} אומנם מציגה ביצועים גבוהים יותר בקרב ${currentWins} מתוך ${totalPeriods} תקופות ההשוואה אל מול קרן ${selectedFundName}.`;
  } else if (selectedWins > currentWins) {
    dynamicPart = `הקרן ב${selectedFundName} אומנם מציגה ביצועים גבוהים יותר בקרב ${selectedWins} מתוך ${totalPeriods} תקופות ההשוואה אל מול קרן ${currentFundName}.`;
  } else {
    dynamicPart = `בהשוואה של ${totalPeriods} תקופות השוואה כל גוף הציג עדיפות בתקופות שונות - ללא הכרעה ברורה.`;
  }

  // 🆕 תיקון בדיקת ותק
  let seniorityDisclosure = '';
  const maxExpectedPeriods = 5;
  
  if (totalPeriods < maxExpectedPeriods) {
    const periods = [
      { key: 'year5', years: 5 },
      { key: 'year4', years: 4 },
      { key: 'year3', years: 3 },
      { key: 'year2', years: 2 }
    ];
    
    let fundWithLimitedSeniority = '';
    let missingPeriodYears = 0;
    
    // בדיקה איזו תקופה ארוכה ביותר חסרה
    for (const period of periods) {
      const currentHasData = currentFundData.returns?.[period.key] !== null && 
                            currentFundData.returns?.[period.key] !== undefined && 
                            !isNaN(currentFundData.returns?.[period.key]);
      const selectedHasData = selectedFund.returns?.[period.key] !== null && 
                             selectedFund.returns?.[period.key] !== undefined && 
                             !isNaN(selectedFund.returns?.[period.key]);
      
      if (!currentHasData && selectedHasData) {
        fundWithLimitedSeniority = currentFundName;
        missingPeriodYears = period.years;
        break;
      } else if (!selectedHasData && currentHasData) {
        fundWithLimitedSeniority = selectedFundName;
        missingPeriodYears = period.years;
        break;
      } else if (!currentHasData && !selectedHasData) {
        fundWithLimitedSeniority = 'אחת הקרנות או שתיהן';
        missingPeriodYears = period.years;
        break;
      }
    }
    
    if (fundWithLimitedSeniority && missingPeriodYears > 0) {
      // 🔧 השינוי החשוב: השתמש ב-totalPeriods בפועל!
      seniorityDisclosure = `\n\nיש לציין כי ${fundWithLimitedSeniority} בעלת ותק של פחות מ-${missingPeriodYears} שנים ולכן תקופות ההשוואה כוללות ${totalPeriods} ${totalPeriods === 1 ? 'שנה' : 'שנים'} בלבד.`;
    }
  }
  
  return `${dynamicPart}${seniorityDisclosure}\n\nעם זאת, הנתונים לבדם אינם מהווים המלצה לביצוע פעולה, ויש לבחון אותם כחלק מתמונה רחבה הכוללת שיקולים אישיים למשקיע/ת – כגון התאמת רמת הסיכון, מדיניות ההשקעה, דמי ניהול, ומשקלה היחסי של הקרן מסך הנכסים הפיננסיים והפנסיוניים שלך.`;
};

useEffect(() => {
  const handleClickOutside = (event) => {
    if (!event.target.closest('.relative')) {
      setShowCurrentFundResults(false);
      setShowSelectedFundResults(false);
      setShowShareOptions(false); // הוסף את השורה הזו
    }
  };

  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);


// 📊 פונקציה ליצירת טקסט בפורמט Word נקי עם רווחים
// const generateShareText = () => {
//   if (!smartAnalysis) return '';

//   try {
//     const { actualWinner, currentFundWins, selectedFundWins, totalPeriods } = smartAnalysis;
    
//     let analysisText = '';
    
//     // 🏆 כותרת ראשית
//     analysisText += `השוואת ${smartAnalysis.currentFundName} מול ${smartAnalysis.selectedFundName}\n`;
//     analysisText += `\n`; // רווח
    
//     // תוצאה כללית
//     if (actualWinner === 'current') {
//       analysisText += `${smartAnalysis.currentFundName} מנצחת את ${smartAnalysis.selectedFundName} ב-${currentFundWins} מתוך ${totalPeriods} מדדי תקופות השוואה\n`;
//     } else if (actualWinner === 'selected') {
//       analysisText += `${smartAnalysis.selectedFundName} מנצחת את ${smartAnalysis.currentFundName} ב-${selectedFundWins} מתוך ${totalPeriods} מדדי תקופות השוואה\n`;
//     } else {
//       analysisText += `בהשוואה של ${totalPeriods} תקופות השוואה כל גוף הציג עדיפות בתקופות שונות - ללא הכרעה ברורה\n`;
//     }
//     analysisText += `\n`; // רווח

//     // 🆕 הוספת גילוי נאות ותק אם רלוונטי
//     const maxExpectedPeriods = 5;
//     if (totalPeriods < maxExpectedPeriods) {
//       const periods = [
//         { key: 'year5', years: 5 },
//         { key: 'year4', years: 4 },
//         { key: 'year3', years: 3 },
//         { key: 'year2', years: 2 }
//       ];
      
//       let fundWithLimitedSeniority = '';
//       let missingPeriodYears = 0;
      
//       for (const period of periods) {
//         const currentHasData = currentFundData?.returns?.[period.key] !== null && 
//                               currentFundData?.returns?.[period.key] !== undefined && 
//                               !isNaN(currentFundData?.returns?.[period.key]);
//         const selectedHasData = selectedFund?.returns?.[period.key] !== null && 
//                                selectedFund?.returns?.[period.key] !== undefined && 
//                                !isNaN(selectedFund?.returns?.[period.key]);
        
//         if (!currentHasData && selectedHasData) {
//           fundWithLimitedSeniority = smartAnalysis.currentFundName;
//           missingPeriodYears = period.years;
//           break;
//         } else if (!selectedHasData && currentHasData) {
//           fundWithLimitedSeniority = smartAnalysis.selectedFundName;
//           missingPeriodYears = period.years;
//           break;
//         } else if (!currentHasData && !selectedHasData) {
//           fundWithLimitedSeniority = 'אחת הקרנות או שתיהן';
//           missingPeriodYears = period.years;
//           break;
//         }
//       }
      
//       if (fundWithLimitedSeniority && missingPeriodYears > 0) {
//         boldText += `יש לציין כי ${fundWithLimitedSeniority} בעלת ותק של פחות מ-${missingPeriodYears} שנים ולכן ההשוואה כוללת ${totalPeriods} ${totalPeriods === 1 ? 'שנה' : 'שנים'} בלבד.\n`;
//         boldText += `\n`; // רווח
//       }
//     }

//     // 🔥 לוגיקה לפי מי מנצח
//     if (actualWinner === 'current') {
//       // הקרן הנוכחית מנצחת
//       const currentWinningPeriods = smartAnalysis.performanceComparison.filter(p => p.currentWins);
//       if (currentWinningPeriods.length > 0) {
//         boldText += `יתרונות ב${smartAnalysis.currentFundName} (המנצחת)\n`;
//         boldText += `\n`; // רווח
//         boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
//         boldText += `\n`; // רווח
        
//         currentWinningPeriods.forEach((period, index) => {
//           boldText += `תשואה מצטברת ${period.period}: ${period.currentReturn}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedReturn}% ב${smartAnalysis.selectedFundName}\n`;
          
//           // הוסף ממוצע שנתי אם קיים - ללא רווח!
//           if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
//             boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName}\n`;
//           }
          
//           boldText += `\n`; // רווח רק בין תקופות שונות
//         });
//       }

//       const currentLosingPeriods = smartAnalysis.performanceComparison.filter(p => !p.currentWins);
//       if (currentLosingPeriods.length > 0) {
//         boldText += `${currentLosingPeriods.length === 1 ? 'חיסרון' : 'חסרונות'} ב${smartAnalysis.currentFundName} (המנצחת):\n`;
//         boldText += `\n`; // רווח
//         boldText += `ביצועים נמוכים יותר בתשואה שנתית נומינלית ברוטו:\n`;
//         boldText += `\n`; // רווח
        
//         currentLosingPeriods.forEach((period, index) => {
//           boldText += `תשואה מצטברת ${period.period}: ${period.currentReturn}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedReturn}% ב${smartAnalysis.selectedFundName}\n`;
          
//           if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
//             boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName}\n`;
//           }
          
//           boldText += `\n`; // רווח רק בין תקופות שונות
//         });
//       }
      
//     } else if (actualWinner === 'selected') {
//       // הקרן הנבחרת מנצחת
//       const selectedWinningPeriods = smartAnalysis.performanceComparison.filter(p => !p.currentWins);
//       if (selectedWinningPeriods.length > 0) {
//         boldText += `יתרונות ב${smartAnalysis.selectedFundName} (המנצחת)\n`;
//         boldText += `\n`; // רווח
//         boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
//         boldText += `\n`; // רווח
        
//         selectedWinningPeriods.forEach((period, index) => {
//           boldText += `תשואה מצטברת ${period.period}: ${period.selectedReturn}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentReturn}% ב${smartAnalysis.currentFundName}\n`;
          
//           if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
//             boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName}\n`;
//           }
          
//           boldText += `\n`; // רווח רק בין תקופות שונות
//         });
//       }

//       const selectedLosingPeriods = smartAnalysis.performanceComparison.filter(p => p.currentWins);
//       if (selectedLosingPeriods.length > 0) {
//         boldText += `${selectedLosingPeriods.length === 1 ? 'חיסרון' : 'חסרונות'} ב${smartAnalysis.selectedFundName} (המנצחת):\n`;
//         boldText += `\n`; // רווח
//         boldText += `ביצועים נמוכים יותר בתשואה שנתית נומינלית ברוטו:\n`;
//         boldText += `\n`; // רווח
        
//         selectedLosingPeriods.forEach((period, index) => {
//           boldText += `תשואה מצטברת ${period.period}: ${period.selectedReturn}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentReturn}% ב${smartAnalysis.currentFundName}\n`;
          
//           if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
//             boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName}\n`;
//           }
          
//           boldText += `\n`; // רווח רק בין תקופות שונות
//         });
//       }
      
//     } else {
//       // תיקו
//       const currentWinningPeriods = smartAnalysis.performanceComparison.filter(p => p.currentWins);
//       if (currentWinningPeriods.length > 0) {
//         boldText += `יתרונות ב${smartAnalysis.currentFundName}:\n`;
//         boldText += `\n`; // רווח
//         boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
//         boldText += `\n`; // רווח
        
//         currentWinningPeriods.forEach((period, index) => {
//           boldText += `תשואה מצטברת ${period.period}: ${period.currentReturn}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedReturn}% ב${smartAnalysis.selectedFundName}\n`;
          
//           if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
//             boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName}\n`;
//           }
          
//           boldText += `\n`; // רווח רק בין תקופות שונות
//         });
//       }

//       const selectedWinningPeriods = smartAnalysis.performanceComparison.filter(p => !p.currentWins);
//       if (selectedWinningPeriods.length > 0) {
//         boldText += `יתרונות ב${smartAnalysis.selectedFundName}:\n`;
//         boldText += `\n`; // רווח
//         boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
//         boldText += `\n`; // רווח
        
//         selectedWinningPeriods.forEach((period, index) => {
//           boldText += `תשואה מצטברת ${period.period}: ${period.selectedReturn}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentReturn}% ב${smartAnalysis.currentFundName}\n`;
          
//           if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
//             boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName}\n`;
//           }
          
//           boldText += `\n`; // רווח רק בין תקופות שונות
//         });
//       }
//     }

//     // 💰 דמי ניהול
//     if (smartAnalysis.feeComparison) {
//       if (smartAnalysis.feeComparison.isEqual) {
//         boldText += `דמי ניהול מהחיסכון זהים:\n`;
//         boldText += `\n`; // רווח
//         boldText += `דמי ניהול מהחיסכון זהים בשתי הקרנות - ${smartAnalysis.feeComparison.currentFee}%\n`;
//       } else {
//         const feeWinnerName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
//         const feeLoserName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.selectedFundName : smartAnalysis.currentFundName;
//         const lowerFee = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.feeComparison.currentFee : smartAnalysis.feeComparison.selectedFee;
//         const higherFee = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.feeComparison.selectedFee : smartAnalysis.feeComparison.currentFee;

//         if (actualWinner === 'tie') {
//           boldText += `יתרון בדמי ניהול ל${feeWinnerName}:\n`;
//           boldText += `\n`; // רווח
//           boldText += `דמי ניהול מהחיסכון נמוכים יותר ${lowerFee}% ב${feeWinnerName} לעומת ${higherFee}% ב${feeLoserName}\n`;
//         } else {
//           const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
//           const performanceWinnerHasFeeAdvantage = feeWinnerName === performanceWinnerName;
          
//           if (performanceWinnerHasFeeAdvantage) {
//             boldText += `יתרון נוסף ב${performanceWinnerName}:\n`;
//             boldText += `\n`; // רווח
//             boldText += `דמי ניהול מהחיסכון נמוכים יותר ${lowerFee}% ב${feeWinnerName} לעומת ${higherFee}% ב${feeLoserName}\n`;
//           } else {
//             boldText += `חיסרון ב${performanceWinnerName} (המנצחת):\n`;
//             boldText += `\n`; // רווח
//             boldText += `דמי ניהול מהחיסכון גבוהים יותר ${higherFee}% ב${feeLoserName} לעומת ${lowerFee}% ב${feeWinnerName}\n`;
//           }
//         }
//       }
//     }

//     // 💰 דמי ניהול מהפקדה לקרנות פנסיה
//     if (isPensionFund() && smartAnalysis.depositFeeComparison) {
//       analysisText += `\n`; // רווח לפני דמי הפקדה
      
//       if (smartAnalysis.depositFeeComparison.isEqual) {
//         boldText += `דמי ניהול מהפקדה זהים:\n`;
//         boldText += `\n`; // רווח
//         boldText += `דמי ניהול מהפקדה זהים בשתי הקרנות - ${smartAnalysis.depositFeeComparison.currentDepositFee}%\n`;
//       } else {
//         const depositFeeWinnerName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
//         const depositFeeLoserName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.selectedFundName : smartAnalysis.currentFundName;
//         const lowerDepositFee = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.depositFeeComparison.currentDepositFee : smartAnalysis.depositFeeComparison.selectedDepositFee;
//         const higherDepositFee = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.depositFeeComparison.selectedDepositFee : smartAnalysis.depositFeeComparison.currentDepositFee;

//         if (actualWinner === 'tie') {
//           boldText += `יתרון בדמי ניהול מהפקדה ל${depositFeeWinnerName}:\n`;
//           boldText += `\n`; // רווח
//           boldText += `דמי ניהול מהפקדה נמוכים יותר ${lowerDepositFee}% ב${depositFeeWinnerName} לעומת ${higherDepositFee}% ב${depositFeeLoserName}\n`;
//         } else {
//           const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
//           const performanceWinnerHasDepositFeeAdvantage = depositFeeWinnerName === performanceWinnerName;
          
//           if (performanceWinnerHasDepositFeeAdvantage) {
//             boldText += `יתרון נוסף בדמי ניהול מהפקדה ב${performanceWinnerName}:\n`;
//             boldText += `\n`; // רווח
//             boldText += `דמי ניהול מהפקדה נמוכים יותר ${lowerDepositFee}% ב${depositFeeWinnerName} לעומת ${higherDepositFee}% ב${depositFeeLoserName}\n`;
//           } else {
//             boldText += `חיסרון בדמי ניהול מהפקדה ב${performanceWinnerName} (המנצחת):\n`;
//             boldText += `\n`; // רווח
//             boldText += `דמי ניהול מהפקדה גבוהים יותר ${higherDepositFee}% ב${depositFeeLoserName} לעומת ${lowerDepositFee}% ב${depositFeeWinnerName}\n`;
//           }
//         }
//       }
//     }

//     return analysisText.trim();
    
//   } catch (error) {
//     console.error('Error generating share text:', error);
//     return 'שגיאה ביצירת טקסט השיתוף';
//   }
// };
// פונקציה עזר להמרת טקסט ל-HTML
const escapeHTML = (text) => {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

// פונקציה להפיכת סוגריים בעברית RTL
const fixRTLParentheses = (text) => {
  // הפיכת סוגריים רגילים לסוגריים עבריים (RTL)
  // ( -> ) ו- ) -> (
  return text
    .replace(/\(/g, '\u200E(') // הוספת LRM לפני סוגריים פתוחים
    .replace(/\)/g, ')\u200E'); // הוספת LRM אחרי סוגריים סגורים
};

// פונקציה להמרת HTML לטקסט רגיל
const htmlToPlainText = (html) => {
  // תחילה, המרת <br> ו-<br/> לרווחים חדשים לפני יצירת האלמנט
  let processedHtml = html
    .replace(/<br\s*\/?>/gi, '\n')  // המרת <br> ו-<br/> ל-\n
    .replace(/<\/div>/gi, '\n')     // המרת </div> ל-\n
    .replace(/<\/p>/gi, '\n\n');     // המרת </p> ל-\n\n
  
  // יצירת אלמנט זמני כדי לחלץ טקסט
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = processedHtml;
  
  // החזרת הטקסט הרגיל עם ניקוי רווחים מיותרים
  let text = tempDiv.textContent || tempDiv.innerText || '';
  
  // ניקוי רווחים מיותרים (יותר מ-2 רווחים חדשים ברצף)
  text = text.replace(/\n{3,}/g, '\n\n');
  
  return text.trim();
};

// 📊 פונקציה ליצירת טקסט שיתוף בפורמט HTML עם bold עד תאריך נכונות הנתונים
const generateShareText = () => {
  if (!smartAnalysis) return '';

  try {
    const { actualWinner, currentFundWins, selectedFundWins, totalPeriods } = smartAnalysis;
    
    // חלק מודגש - עד תאריך נכונות הנתונים
    let boldText = '';
    
    // כותרת ראשית
    boldText += `השוואת ${smartAnalysis.currentFundName} מול ${smartAnalysis.selectedFundName}`;

    
    // תוצאה כללית
    if (actualWinner === 'current') {
      boldText += `\n${smartAnalysis.currentFundName} מנצחת את ${smartAnalysis.selectedFundName} ב-${currentFundWins} מתוך ${totalPeriods} מדדי תקופות השוואה\n`;
    } else if (actualWinner === 'selected') {
      boldText += `\n${smartAnalysis.selectedFundName} מנצחת את ${smartAnalysis.currentFundName} ב-${selectedFundWins} מתוך ${totalPeriods} מדדי תקופות השוואה\n`;
    } else {
      boldText += `\nבהשוואה של ${totalPeriods} תקופות השוואה כל גוף הציג עדיפות בתקופות שונות - ללא הכרעה ברורה\n`;
    }
  
    boldText +='\n'
    // לוגיקה לפי מי מנצח
    if (actualWinner === 'current') {
      // הקרן הנוכחית מנצחת
      const currentWinningPeriods = smartAnalysis.performanceComparison.filter(p => p.currentWins);
      if (currentWinningPeriods.length > 0) {
        boldText += `יתרונות ב${smartAnalysis.currentFundName} (המנצחת) \n`;
boldText +='\n'
        boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
      boldText +='\n'
      
        
        currentWinningPeriods.forEach(period => {
          // המרת תקופה לפורמט הנדרש
          let periodLabel = period.period;
          if (period.key === 'year1') {
            periodLabel = '12 אחרונים';
          } else if (period.key === 'year2') {
            periodLabel = 'ל-2 השנים אחרונות';
          } else if (period.key === 'year3') {
            periodLabel = 'ל-3 השנים אחרונות';
          } else if (period.key === 'year4') {
            periodLabel = 'ל-4 השנים אחרונות';
          } else if (period.key === 'year5') {
            periodLabel = '5 שנים אחרונות';
          }
          
          boldText += `תשואה מצטברת ${periodLabel} : ${period.currentReturn}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedReturn}%  ב${smartAnalysis.selectedFundName}\n`;
          
          // הוסף ממוצע שנתי אם קיים - ביחד עם התשואה המצטברת
          // if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
          //   boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName} לעומת  ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName}\n`;
          // }
          // boldText += `\n`;
        });
      }

      const currentLosingPeriods = smartAnalysis.performanceComparison.filter(p => !p.currentWins);
      if (currentLosingPeriods.length > 0) {
        boldText += `${currentLosingPeriods.length === 1 ? 'חיסרון' : 'חסרונות'} ב${smartAnalysis.currentFundName} (המנצחת):\n`;
        
        
        currentLosingPeriods.forEach(period => {
          boldText += `תשואה מצטברת ${period.period}: ${period.currentReturn}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedReturn}% ב${smartAnalysis.selectedFundName}\n`;
          
          // if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
          //   boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName}\n`;
          // }
    
        });
      }
      
    } else if (actualWinner === 'selected') {
      // הקרן הנבחרת מנצחת
      const selectedWinningPeriods = smartAnalysis.performanceComparison.filter(p => !p.currentWins);
      if (selectedWinningPeriods.length > 0) {
        boldText += `יתרונות ב${smartAnalysis.selectedFundName} (המנצחת)\n`;
        boldText += `\n`;
        boldText += `\n`;
        boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
        boldText += `\n`;
        boldText += `\n`;
        
        selectedWinningPeriods.forEach(period => {
          let periodLabel = period.period;
          if (period.key === 'year1') {
            periodLabel = '12 אחרונים';
          } else if (period.key === 'year2') {
            periodLabel = 'ל-2 השנים אחרונות';
          } else if (period.key === 'year3') {
            periodLabel = 'ל-3 השנים אחרונות';
          } else if (period.key === 'year4') {
            periodLabel = 'ל-4 השנים אחרונות';
          } else if (period.key === 'year5') {
            periodLabel = '5 שנים אחרונות';
          }
          
          boldText += `תשואה מצטברת ${periodLabel} : ${period.selectedReturn}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentReturn}%  ב${smartAnalysis.currentFundName}\n`;
          
          // if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
          //   boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName} לעומת  ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName}\n`;
          // }
         
        });
      }

      const selectedLosingPeriods = smartAnalysis.performanceComparison.filter(p => p.currentWins);
      if (selectedLosingPeriods.length > 0) {
        boldText += `${selectedLosingPeriods.length === 1 ? 'חיסרון' : 'חסרונות'} ב${smartAnalysis.selectedFundName} (המנצחת):\n`;
    
        
        selectedLosingPeriods.forEach(period => {
          boldText += `תשואה מצטברת ${period.period}: ${period.selectedReturn}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentReturn}% ב${smartAnalysis.currentFundName}\n`;
          
          // if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
          //   boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName}\n`;
          // }
          
       
        });
      }
      
    } else {
      // תיקו
      const currentWinningPeriods = smartAnalysis.performanceComparison.filter(p => p.currentWins);
      if (currentWinningPeriods.length > 0) {
        boldText += `יתרונות ב${smartAnalysis.currentFundName}:\n`;
 
        boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
  
        
        currentWinningPeriods.forEach(period => {
          let periodLabel = period.period;
          if (period.key === 'year1') {
            periodLabel = '12 אחרונים';
          } else if (period.key === 'year2') {
            periodLabel = 'ל-2 השנים אחרונות';
          } else if (period.key === 'year3') {
            periodLabel = 'ל-3 השנים אחרונות';
          } else if (period.key === 'year4') {
            periodLabel = 'ל-4 השנים אחרונות';
          } else if (period.key === 'year5') {
            periodLabel = '5 שנים אחרונות';
          }
          
          boldText += `תשואה מצטברת ${periodLabel} : ${period.currentReturn}% ב${smartAnalysis.currentFundName} לעומת ${period.selectedReturn}%  ב${smartAnalysis.selectedFundName}\n`;
          boldText += `\n`;
          
          // if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
          //   boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName} לעומת  ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName}\n`;
          //   boldText += `\n`;
          // }
        });
      }

      const selectedWinningPeriods = smartAnalysis.performanceComparison.filter(p => !p.currentWins);
      if (selectedWinningPeriods.length > 0) {
        boldText += `יתרונות ב${smartAnalysis.selectedFundName}:\n`;

        boldText += `ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:\n`;
  
        
        selectedWinningPeriods.forEach(period => {
          let periodLabel = period.period;
          if (period.key === 'year1') {
            periodLabel = '12 אחרונים';
          } else if (period.key === 'year2') {
            periodLabel = 'ל-2 השנים אחרונות';
          } else if (period.key === 'year3') {
            periodLabel = 'ל-3 השנים אחרונות';
          } else if (period.key === 'year4') {
            periodLabel = 'ל-4 השנים אחרונות';
          } else if (period.key === 'year5') {
            periodLabel = '5 שנים אחרונות';
          }
          
          boldText += `תשואה מצטברת ${periodLabel} : ${period.selectedReturn}% ב${smartAnalysis.selectedFundName} לעומת ${period.currentReturn}%  ב${smartAnalysis.currentFundName}\n`;
          
          // if (period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) {
          //   boldText += `תשואה ממוצעת לכל שנה ב-${period.years * 12} החודשים האחרונים ${period.selectedAnnualAvg.toFixed(2)}% ב${smartAnalysis.selectedFundName} לעומת  ${period.currentAnnualAvg.toFixed(2)}% ב${smartAnalysis.currentFundName}\n`;
          // }
    
        });
      }
    }

    // דמי ניהול
    if (smartAnalysis.feeComparison) {
      if (smartAnalysis.feeComparison.isEqual) {
        boldText += `דמי ניהול מהחיסכון זהים:\n`;
        
        boldText += `דמי ניהול מהחיסכון זהים בשתי הקרנות - ${smartAnalysis.feeComparison.currentFee}%\n`;
      } else {
        const feeWinnerName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
        const feeLoserName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.selectedFundName : smartAnalysis.currentFundName;
        const lowerFee = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.feeComparison.currentFee : smartAnalysis.feeComparison.selectedFee;
        const higherFee = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.feeComparison.selectedFee : smartAnalysis.feeComparison.currentFee;

        if (actualWinner === 'tie') {
          boldText += `יתרון בדמי ניהול ל${feeWinnerName}:\n`;
          
          boldText += `דמי ניהול מהחיסכון נמוכים יותר ${lowerFee}% ב${feeWinnerName} לעומת ${higherFee}% ב${feeLoserName}\n`;
        } else {
          const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
          const performanceWinnerHasFeeAdvantage = feeWinnerName === performanceWinnerName;
          
          if (performanceWinnerHasFeeAdvantage) {
            boldText += `יתרון נוסף ב${performanceWinnerName}:\n`;
      
            boldText += `דמי ניהול מהחיסכון נמוכים יותר ${lowerFee}% ב${feeWinnerName} לעומת ${higherFee}% ב${feeLoserName}\n`;
          } else {
            boldText += `חיסרון ב${performanceWinnerName} (המנצחת):\n`;
         
            boldText += `דמי ניהול מהחיסכון נמוכים יותר ${lowerFee}% ב${feeLoserName} לעומת  ${higherFee}% ב${feeWinnerName}\n`;
          }
        }
      }

    }

    if (isPensionFund() && smartAnalysis.depositFeeComparison) {
      if (smartAnalysis.depositFeeComparison.isEqual) {
        boldText += `דמי ניהול מהפקדה זהים:\n`;
      
        boldText += `דמי ניהול מהפקדה זהים בשתי הקרנות - ${smartAnalysis.depositFeeComparison.currentDepositFee}%\n`;
      } else {
        const depositFeeWinnerName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
        const depositFeeLoserName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.selectedFundName : smartAnalysis.currentFundName;
        const lowerDepositFee = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.depositFeeComparison.currentDepositFee : smartAnalysis.depositFeeComparison.selectedDepositFee;
        const higherDepositFee = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.depositFeeComparison.selectedDepositFee : smartAnalysis.depositFeeComparison.currentDepositFee;

        if (actualWinner === 'tie') {
          boldText += `יתרון בדמי ניהול מהפקדה ל${depositFeeWinnerName}:\n`;
        
          boldText += `דמי ניהול מהפקדה נמוכים יותר ${lowerDepositFee}% ב${depositFeeWinnerName} לעומת ${higherDepositFee}% ב${depositFeeLoserName}\n`;
        } else {
          const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
          const performanceWinnerHasDepositFeeAdvantage = depositFeeWinnerName === performanceWinnerName;
          
          if (performanceWinnerHasDepositFeeAdvantage) {
            boldText += `יתרון נוסף בדמי ניהול מהפקדה ב${performanceWinnerName}:\n`;
          
            boldText += `דמי ניהול מהפקדה נמוכים יותר ${lowerDepositFee}% ב${depositFeeWinnerName} לעומת ${higherDepositFee}% ב${depositFeeLoserName}\n`;
          } else {
            boldText += `חיסרון בדמי ניהול מהפקדה ב${performanceWinnerName} (המנצחת):\n`;
        
            boldText += `דמי ניהול מהפקדה גבוהים יותר ${higherDepositFee}% ב${depositFeeLoserName} לעומת ${lowerDepositFee}% ב${depositFeeWinnerName}\n`;
          }
        }
      }
  
    }
    let normalText = '';
    // תאריך נכונות הנתונים - סוף החלק המודגש
    normalText += `\n📅 תאריך נכונות הנתונים: ${lastUpdated}\n`;

    // חלק רגיל - לא מודגש
 
    normalText += `\n©️📊 מקור: כל הזכויות שמורות לגמלנט AI – ניתוח השוואה חכם בין מוצרי השקעה פנסיוניים ופיננסיים. \n`;
    normalText += `\n━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    normalText += `\n🔗 קישור לפרטי הקרן הנוכחית שלך (${smartAnalysis.currentFundName}): https://gemelnet.ai/product/${category}/${currentFundId}\n`;
    normalText += `🔗 קישור לפרטי הקרן להשוואה (${smartAnalysis.selectedFundName}): https://gemelnet.ai/product/${category}/${selectedFund.id}\n`;
    normalText += `━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    normalText += `\n📊 המידע באתר גמל נט AI נועד להנגיש תובנות והשוואות, אך אינו מהווה ייעוץ פנסיוני, פיננסי או השקעות.\n`;
    normalText += `📄✅ כל החלטה צריכה להיעשות תוך התאמה אישית ובליווי בעל רישיון מוסמך בלבד.\n`;

    // המרה ל-HTML עם bold - שמירה על רווחים עם <br> tags
    // תחילה נמיר רווחים כפולים ל-<br><br>, ואז רווחים בודדים ל-<br>
    // תיקון סוגריים בעברית RTL
    const boldTextFixed = fixRTLParentheses(boldText.trim());
    const normalTextFixed = fixRTLParentheses(normalText.trim());
    
    const boldHtml = escapeHTML(boldTextFixed)
      .replace(/\n\n+/g, '<br><br>')
      .replace(/\n/g, '<br>');
    const normalHtml = escapeHTML(normalTextFixed)
      .replace(/\n\n+/g, '<br><br>')
      .replace(/\n/g, '<br>');
    // הוספת dir="rtl" וסגנונות CSS כדי לתקן את הסוגריים בעברית ולקבוע גודל וגופן
    const htmlText = `<div dir="rtl" lang="he" style="font-size: 9pt; font-family: Arial, sans-serif; line-height: 1.5; color: #000000;"><b>${boldHtml}</b>${normalHtml}</div>`;
    
    return htmlText;
    
  } catch (error) {
    console.error('Error generating share text:', error);
    return 'שגיאה ביצירת טקסט השיתוף';
  }
};

const copySmartAnalysis = async () => {
  if (!smartAnalysis) return;

  try {
    const htmlText = generateShareText();
    const plainText = htmlToPlainText(htmlText);
    
    // יצירת HTML clipboard format
    const htmlBlob = new Blob([htmlText], { type: 'text/html' });
    const textBlob = new Blob([plainText], { type: 'text/plain' });
    
    const clipboardItem = new ClipboardItem({
      'text/html': htmlBlob,
      'text/plain': textBlob
    });
    
    await navigator.clipboard.write([clipboardItem]);

    setCopyMessage('הועתק!');
    setTimeout(() => setCopyMessage(''), 2000);
  } catch (error) {
    console.error('Copy error:', error);
    // Fallback לטקסט רגיל אם HTML clipboard לא עובד
    try {
      const htmlText = generateShareText();
      const plainText = htmlToPlainText(htmlText);
      await navigator.clipboard.writeText(plainText);
      setCopyMessage('הועתק!');
      setTimeout(() => setCopyMessage(''), 2000);
    } catch (fallbackError) {
      console.error('Fallback copy error:', fallbackError);
      setCopyMessage('שגיאה');
      setTimeout(() => setCopyMessage(''), 2000);
    }
  }
};


const handleShare = async () => {
  if (!smartAnalysis) return;

  const htmlText = generateShareText();
  const shareText = htmlToPlainText(htmlText);
  const shareData = {
    title: `השוואת קרנות: ${smartAnalysis.currentFundName} vs ${smartAnalysis.selectedFundName}`,
    text: shareText,
  };

  // בדיקה אם יש תמיכה ב-Web Share API (בעיקר במובייל)
  if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
    try {
      await navigator.share(shareData);
      setShareMessage('שותף!');
      setTimeout(() => setShareMessage(''), 2000);
    } catch (error) {
      if (error.name !== 'AbortError') {
        // אם השיתוף נכשל, נציג אפשרויות חלופיות
        setShowShareOptions(true);
      }
    }
  } else {
    // אם אין תמיכה ב-Web Share API, נציג אפשרויות שיתוף
    setShowShareOptions(true);
  }
};
  const handleWhatsAppShare = () => {
  const htmlText = generateShareText();
  const shareText = htmlToPlainText(htmlText);
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
  window.open(whatsappUrl, '_blank');
  setShowShareOptions(false);
  setShareMessage('שותף בוואטסאפ!');
  setTimeout(() => setShareMessage(''), 2000);
};

const handleEmailShare = () => {
  const htmlText = generateShareText();
  const shareText = htmlToPlainText(htmlText);
  const subject = `השוואת קרנות: ${smartAnalysis.currentFundName} vs ${smartAnalysis.selectedFundName}`;
  const emailUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(shareText)}`;
  window.location.href = emailUrl;
  setShowShareOptions(false);
  setShareMessage('נפתח במייל!');
  setTimeout(() => setShareMessage(''), 2000);
};
const exportAnalysisAsImage = async () => {
  if (!analysisRef.current) {
    alert('שגיאה בטעינת הניתוח');
    return;
  }

  try {
    // שמור רוחב מקורי
    const originalWidth = analysisRef.current.style.width;
    const originalMinWidth = analysisRef.current.style.minWidth;
    const originalMaxWidth = analysisRef.current.style.maxWidth;
    
    // קבע רוחב קבוע לתמונה (1200px נראה טוב)
    analysisRef.current.style.width = '1200px';
    analysisRef.current.style.minWidth = '1200px';
    analysisRef.current.style.maxWidth = '1200px';
    
    // מצא את כל האלמנטים עם טקסט חתוך
    const truncatedElements = analysisRef.current.querySelectorAll('.truncate, [class*="truncate"]');
    const originalStyles = [];
    
    // בטל את החיתוך זמנית
    truncatedElements.forEach(el => {
      originalStyles.push({
        element: el,
        overflow: el.style.overflow,
        textOverflow: el.style.textOverflow,
        whiteSpace: el.style.whiteSpace,
        maxWidth: el.style.maxWidth
      });
      
      el.style.overflow = 'visible';
      el.style.textOverflow = 'clip';
      el.style.whiteSpace = 'normal';
      el.style.maxWidth = 'none';
    });
    
    // הסתר כפתורי פעולה וסעיף "מה הלאה?" זמנית
    const actionButtons = analysisRef.current.querySelectorAll('button');
    const nextStepsSection = analysisRef.current.querySelector('.next-steps-section');
    
    // שמור מצבים מקוריים
    const hiddenElements = [];
    
    actionButtons.forEach(btn => {
      hiddenElements.push({ element: btn, visibility: btn.style.visibility });
      btn.style.visibility = 'hidden';
    });
    
    if (nextStepsSection) {
      hiddenElements.push({ element: nextStepsSection, display: nextStepsSection.style.display });
      nextStepsSection.style.display = 'none';
    }

    // המתן לרינדור מחדש
    await new Promise(resolve => setTimeout(resolve, 300));

    // צלם את הניתוח
    const canvas = await html2canvas(analysisRef.current, {
      backgroundColor: '#ffffff',
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true,
      width: 1200,
      windowWidth: 1200
    });

    // החזר רוחב מקורי
    analysisRef.current.style.width = originalWidth;
    analysisRef.current.style.minWidth = originalMinWidth;
    analysisRef.current.style.maxWidth = originalMaxWidth;
    
    // החזר את כל הסגנונות המקוריים
    originalStyles.forEach(({ element, overflow, textOverflow, whiteSpace, maxWidth }) => {
      element.style.overflow = overflow;
      element.style.textOverflow = textOverflow;
      element.style.whiteSpace = whiteSpace;
      element.style.maxWidth = maxWidth;
    });
    
    // החזר את כל האלמנטים למצב המקורי
    hiddenElements.forEach(({ element, visibility, display }) => {
      if (visibility !== undefined) element.style.visibility = visibility;
      if (display !== undefined) element.style.display = display;
    });

    // המר לתמונה והורד
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `AI_Analysis_${smartAnalysis.currentFundName}_vs_${smartAnalysis.selectedFundName}_${new Date().toISOString().split('T')[0]}.png`;
      
      link.href = url;
      link.download = fileName;
      link.click();
      
      URL.revokeObjectURL(url);
      
      setShareMessage('התמונה הורדה!');
      setTimeout(() => setShareMessage(''), 2000);
    });

  } catch (error) {
    console.error('שגיאה בייצוא תמונה:', error);
    alert('אירעה שגיאה בהורדת התמונה');
  }
};
const handleCopyForShare = async () => {
  const htmlText = generateShareText();
  const shareText = htmlToPlainText(htmlText);
  try {
    await navigator.clipboard.writeText(shareText);
    setShowShareOptions(false);
    setShareMessage('הועתק לשיתוף!');
    setTimeout(() => setShareMessage(''), 2000);
  } catch (error) {
    setShareMessage('שגיאה');
    setTimeout(() => setShareMessage(''), 2000);
  }
};


  // פונקציה לייצוא 3 דפי תמונה ישירות
  const exportAll3PagesAsImages = async () => {
    if (!currentFundId || !selectedFund?.id) {
      alert('אנא בחר קרן להשוואה');
      return;
    }

    try {
      setShareMessage('מייצא 3 דפי תמונה...');
      
      // טעינת נתונים נוספים אם צריך
      const fund1Data = currentFundData || await api.getProductById(currentFundId, category);
      const fund2Data = selectedFund || await api.getProductById(selectedFund.id, category);

      // מציאת התמחויות
      const [spec1, spec2] = await Promise.all([
        matchingSpecialization || getEnhancedSpecializationMatch(fund1Data, category, api),
        getEnhancedSpecializationMatch(fund2Data, category, api)
      ]);

      // תאריך עדכון
      const date1 = fund1Data.reportPeriod || fund1Data.lastUpdated || lastUpdated;
      const date2 = fund2Data.reportPeriod || fund2Data.lastUpdated || lastUpdated;
      const lastUpdateDate = date1 > date2 ? date1 : date2;

      // יצירת קונטיינר זמני מחוץ למסך - כל 3 הדפים בקובץ אחד
      const tempContainer = document.createElement('div');
      tempContainer.style.cssText = 'position: fixed; left: -9999px; top: 0; width: 1200px; background: white; z-index: -1;';
      document.body.appendChild(tempContainer);

      // קונטיינר ראשי לכל הדפים
      const allPagesContainer = document.createElement('div');
      allPagesContainer.style.cssText = 'width: 1200px; background: white; direction: rtl !important; white-space: normal !important; word-spacing: normal !important; letter-spacing: normal !important;';
      allPagesContainer.setAttribute('dir', 'rtl');
      tempContainer.appendChild(allPagesContainer);

      // יצירת 3 דפים - כולם באותו קונטיינר
      const pages = [
        {
          name: 'קרן_1',
          fund: fund1Data,
          spec: spec1,
          fundId: currentFundId
        },
        {
          name: 'קרן_2',
          fund: fund2Data,
          spec: spec2,
          fundId: selectedFund.id
        },
        {
          name: 'השוואה',
          isComparison: true
        }
      ];

      // יצירת כל הדפים באותו קונטיינר
      const rootsToCleanup = [];
      const returnsContainers = []; // שמירת references ל-ReturnsSection containers
      
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        
        // יצירת div לדף
        const pageDiv = document.createElement('div');
        pageDiv.style.cssText = 'width: 1200px; background: white; padding: 20px; page-break-after: always;';
        allPagesContainer.appendChild(pageDiv);

        if (page.isComparison) {
          // דף השוואה - נשתמש ב-analysisRef הקיים
          if (!analysisRef.current || !smartAnalysis) {
            alert('אנא הפעל ניתוח AI קודם');
            document.body.removeChild(tempContainer);
            setShareMessage('');
            return;
          }
          
          // העתק את תוכן ההשוואה
          const comparisonClone = analysisRef.current.cloneNode(true);
          comparisonClone.style.width = '1200px';
          comparisonClone.style.minWidth = '1200px';
          comparisonClone.style.maxWidth = '1200px';
          
          // הסתר כפתורים
          comparisonClone.querySelectorAll('button').forEach(btn => {
            btn.style.visibility = 'hidden';
          });
          const nextSteps = comparisonClone.querySelector('.next-steps-section');
          if (nextSteps) nextSteps.style.display = 'none';
          
          pageDiv.appendChild(comparisonClone);
          
          // הוסף קישורים והבהרה משפטית
          const linksDiv = document.createElement('div');
          linksDiv.className = 'mt-4 border-t pt-2';
          linksDiv.style.cssText = 'margin-top: 1rem !important; padding-top: 0.5rem !important;';
          linksDiv.innerHTML = `
            <h3 class="text-sm font-bold text-gray-900 mb-1" style="font-size: 0.75rem !important; margin-bottom: 0.25rem !important;">קישורים נוספים</h3>
            <div class="flex flex-wrap gap-2 mb-2" style="margin-bottom: 0.5rem !important;">
              <a href="/product/${category}/${currentFundId}" class="text-blue-600 hover:text-blue-800 underline" style="font-size: 0.65rem !important;">קישור לקרן 1: ${getDisplayName(fund1Data)}</a>
              <a href="/product/${category}/${selectedFund.id}" class="text-blue-600 hover:text-blue-800 underline" style="font-size: 0.65rem !important;">קישור לקרן 2: ${getDisplayName(fund2Data)}</a>
            </div>
            <div class="mt-2 border-t pt-2" style="margin-top: 0.5rem !important; padding-top: 0.5rem !important;">
              <h3 class="text-xs font-bold text-gray-700 mb-1" style="font-size: 0.7rem !important; margin-bottom: 0.25rem !important;">⚠️ הבהרה משפטית</h3>
              <div class="text-xs text-gray-600" style="font-size: 0.6rem !important; line-height: 1.3 !important;">
                <p style="margin: 0.15rem 0 !important;">📊 המידע באתר גמל נט AI נועד להנגיש תובנות והשוואות, אך אינו מהווה ייעוץ פנסיוני, פיננסי או השקעות.</p>
                <p style="margin: 0.15rem 0 !important;">📄✅ כל החלטה צריכה להיעשות תוך התאמה אישית ובליווי בעל רישיון מוסמך בלבד.</p>
                <p style="margin: 0.15rem 0 !important;">⏳ תשואות עבר אינן מעידות בהכרח על ביצועים עתידיים, ואין לראות בנתונים באתר התחייבות או המלצה.</p>
                <p style="margin: 0.15rem 0 !important;">🧠 אנו עושים מאמץ כנה בשילוב מערכות בינה מלאכותית מתקדמות לספק מידע מדויק, אך האחריות לשימוש בו ולפרשנותו היא בידי המשתמש בלבד.</p>
              </div>
            </div>
          `;
          pageDiv.appendChild(linksDiv);
        } else {
          // דף קרן - יצירת תוכן עם React
          const headerDiv = document.createElement('div');
          headerDiv.className = 'mb-6 border-b pb-6';
          headerDiv.style.cssText = 'display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 20px; position: relative;';
          
          // לוגו - בצד ימין (בגלל RTL, צריך להשתמש ב-right: 0)
          if (page.fund.managingCorpLegalId) {
            const logo = document.createElement('img');
            logo.src = `/logos/${page.fund.managingCorpLegalId}.png`;
            logo.alt = page.fund.company || 'לוגו חברה';
            logo.style.cssText = 'height: 160px; width: 160px; object-fit: contain; flex-shrink: 0; position: absolute; right: 0;';
            logo.onerror = () => { logo.style.display = 'none'; };
            headerDiv.appendChild(logo);
          }
          
          // מיכל לטקסט (שם הקרן ורמת סיכון) - באמצע
          const textContainer = document.createElement('div');
          textContainer.style.cssText = 'flex: 1; text-align: center;';
          
          // שם הקרן במקום שם המסלול
          const fundTitle = document.createElement('h2');
          fundTitle.className = 'text-2xl font-bold text-gray-900 mb-2';
          fundTitle.textContent = getDisplayName(page.fund);
          textContainer.appendChild(fundTitle);
          
          if (page.fund.riskLevel) {
            const risk = document.createElement('p');
            risk.className = 'text-lg text-gray-600';
            risk.textContent = `רמת סיכון: ${page.fund.riskLevel.level} מתוך 5`;
            textContainer.appendChild(risk);
          }
          
          headerDiv.appendChild(textContainer);
          
          pageDiv.appendChild(headerDiv);

          // יצירת ReturnsSection עם React
          const returnsContainer = document.createElement('div');
          pageDiv.appendChild(returnsContainer);
          returnsContainers.push(returnsContainer); // שמירת reference
          
          const root = createRoot(returnsContainer);
          rootsToCleanup.push({ root, container: returnsContainer });
          root.render(
            React.createElement(ReturnsSection, {
              product: page.fund,
              category: category,
              currentProductId: page.fundId,
              matchingSpecialization: page.spec,
              lastUpdated: lastUpdateDate
            })
          );

          // ExposuresSection - מדדי הפיזור העיקריים והחשובים
          const exposuresDiv = document.createElement('div');
          exposuresDiv.className = 'bg-white rounded-xl shadow-md border border-gray-100 p-4 mb-6';
          
          // חישוב הנתונים
          const stocksExposure = page.fund.exposures?.stocks || 0;
          const currencyExposure = page.fund.exposures?.currency || 0;
          const illiquidAssets = page.fund.performance?.liquidAssetsPercent ? 
            (100 - page.fund.performance.liquidAssetsPercent) : 0;
          
          // כותרת ראשית - פיזור חשיפה במונחי דלתא
          const mainTitle = document.createElement('h3');
          mainTitle.className = 'text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6 text-center';
          mainTitle.textContent = 'פיזור חשיפה במונחי דלתא';
          exposuresDiv.appendChild(mainTitle);
          
          // כותרת משנה - מדדי הפיזור העיקריים והחשובים
          const subTitle = document.createElement('h4');
          subTitle.className = 'font-semibold text-gray-900 mb-3 md:mb-6 text-center text-base md:text-lg';
          subTitle.textContent = 'מדדי הפיזור העיקריים והחשובים';
          exposuresDiv.appendChild(subTitle);
          
          // קונטיינר לעיגולים
          const circlesContainer = document.createElement('div');
          circlesContainer.className = 'grid grid-cols-3 gap-2 md:gap-4';
          
          // פונקציה ליצירת עיגול
          const createCircularProgress = (percentage, label, color, size, strokeWidth, textSize, labelSize) => {
            const radius = (size - strokeWidth) / 2;
            const circumference = radius * 2 * Math.PI;
            const strokeDashoffset = circumference - (percentage / 100) * circumference;
            
            const container = document.createElement('div');
            container.className = 'flex flex-col items-center';
            
            const svgContainer = document.createElement('div');
            svgContainer.className = 'relative';
            svgContainer.style.width = `${size}px`;
            svgContainer.style.height = `${size}px`;
            
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', size);
            svg.setAttribute('height', size);
            svg.setAttribute('style', 'transform: rotate(-90deg);');
            
            // רקע העיגול
            const bgCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            bgCircle.setAttribute('cx', size / 2);
            bgCircle.setAttribute('cy', size / 2);
            bgCircle.setAttribute('r', radius);
            bgCircle.setAttribute('stroke', '#E5E7EB'); // gray-200
            bgCircle.setAttribute('stroke-width', strokeWidth);
            bgCircle.setAttribute('fill', 'transparent');
            svg.appendChild(bgCircle);
            
            // העיגול המתמלא
            const progressCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            progressCircle.setAttribute('cx', size / 2);
            progressCircle.setAttribute('cy', size / 2);
            progressCircle.setAttribute('r', radius);
            progressCircle.setAttribute('stroke', color);
            progressCircle.setAttribute('stroke-width', strokeWidth);
            progressCircle.setAttribute('fill', 'transparent');
            progressCircle.setAttribute('stroke-dasharray', circumference);
            progressCircle.setAttribute('stroke-dashoffset', strokeDashoffset);
            progressCircle.setAttribute('stroke-linecap', 'round');
            svg.appendChild(progressCircle);
            
            svgContainer.appendChild(svg);
            
            // טקסט במרכז
            const textDiv = document.createElement('div');
            textDiv.className = `absolute inset-0 flex items-center justify-center ${textSize} font-bold`;
            textDiv.setAttribute('dir', 'ltr');
            textDiv.textContent = `${percentage.toFixed(2)}%`;
            svgContainer.appendChild(textDiv);
            
            container.appendChild(svgContainer);
            
            // תווית
            const labelSpan = document.createElement('span');
            labelSpan.className = `mt-2 text-center text-gray-700 font-medium ${labelSize || textSize}`;
            labelSpan.textContent = label;
            container.appendChild(labelSpan);
            
            return container;
          };
          
          // יצירת 3 העיגולים - מוגדלים
          circlesContainer.appendChild(createCircularProgress(
            stocksExposure,
            'חשיפה למניות',
            '#10B981',
            100,
            6,
            'text-base',
            'text-sm'
          ));
          
          circlesContainer.appendChild(createCircularProgress(
            currencyExposure,
            'חשיפה למט״ח',
            '#8B5CF6',
            100,
            6,
            'text-base',
            'text-sm'
          ));
          
          circlesContainer.appendChild(createCircularProgress(
            illiquidAssets,
            'נכסים לא סחירים',
            '#EF4444',
            100,
            6,
            'text-base',
            'text-sm'
          ));
          
          exposuresDiv.appendChild(circlesContainer);
          pageDiv.appendChild(exposuresDiv);
          
          // הוסף תמונת VS אחרי הקרן הראשונה
          if (i === 0) {
            const separatorDiv = document.createElement('div');
            separatorDiv.style.cssText = 'width: 1200px; padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;';
            
            // תמונת VS
            const vsImg = document.createElement('img');
            vsImg.src = '/vstransp.png';
            vsImg.alt = 'VS';
            vsImg.style.cssText = 'height: 120px; width: auto; object-fit: contain;';
            vsImg.onerror = () => { vsImg.style.display = 'none'; };
            separatorDiv.appendChild(vsImg);
            
            allPagesContainer.appendChild(separatorDiv);
          }
        }
      }

      // המתן לרינדור של כל הדפים (יותר זמן כדי שהפיזור חשיפה יתרנדר)
      await new Promise(resolve => setTimeout(resolve, 3000));

      // יישום תיקוני ייצוא על ReturnsSection (כמו ב-ReturnsSection.js)
      const originalBackgrounds = [];
      const originalTitleStyles = [];
      const originalPerformanceLabelStyles = [];
      const originalCardStyles = [];
      const originalValueStyles = [];
      const originalRankBadgeStyles = [];
      const styleElements = [];
      
      returnsContainers.forEach(container => {
        // מצא את ה-ReturnsSection
        const returnsSection = container.querySelector('[class*="bg-white rounded-2xl"]') || container.firstElementChild;
        if (!returnsSection) return;
        
        // תיקון צבע הכותרת "דירוג ביצועים" - שנה לשחור
        const rankingTitles = returnsSection.querySelectorAll('h3');
        rankingTitles.forEach(title => {
          if (title.textContent?.includes('דירוג ביצועים')) {
            originalTitleStyles.push({
              element: title,
              color: title.style.color,
              background: title.style.background,
              webkitBackgroundClip: title.style.webkitBackgroundClip,
              backgroundClip: title.style.backgroundClip,
              webkitTextFillColor: title.style.webkitTextFillColor,
              className: title.className
            });
            title.style.color = '#000000';
            title.style.background = 'none';
            title.style.webkitBackgroundClip = 'unset';
            title.style.backgroundClip = 'unset';
            title.style.webkitTextFillColor = 'unset';
            title.className = title.className.replace(/bg-gradient-to-r|bg-clip-text|text-transparent/g, '').trim();
          }
        });
        
        // תיקון צבעים בעיגולים - הוסף רקע צבעוני ו-border מוצק
        const neonCards = returnsSection.querySelectorAll('.neon-card');
        neonCards.forEach(card => {
          const performanceClass = card.className.match(/excellent|good|average|below|poor/)?.[0];
          if (performanceClass) {
            originalCardStyles.push({
              element: card,
              border: card.style.border,
              borderWidth: card.style.borderWidth,
              borderStyle: card.style.borderStyle,
              borderColor: card.style.borderColor,
              boxShadow: card.style.boxShadow,
              background: card.style.background,
              backgroundColor: card.style.backgroundColor
            });
            
            const colorMap = {
              excellent: { 
                border: '#10b981', 
                shadow: '0 0 15px rgba(16, 185, 129, 0.4)', 
                textColor: '#047857',
                bgColor: 'rgba(16, 185, 129, 0.1)'
              },
              good: { 
                border: '#22c55e', 
                shadow: '0 0 15px rgba(34, 197, 94, 0.4)', 
                textColor: '#15803d',
                bgColor: 'rgba(34, 197, 94, 0.1)'
              },
              average: { 
                border: '#eab308', 
                shadow: '0 0 15px rgba(234, 179, 8, 0.4)', 
                textColor: '#a16207',
                bgColor: 'rgba(234, 179, 8, 0.1)'
              },
              below: { 
                border: '#f97316', 
                shadow: '0 0 15px rgba(249, 115, 22, 0.4)', 
                textColor: '#c2410c',
                bgColor: 'rgba(249, 115, 22, 0.1)'
              },
              poor: { 
                border: '#ef4444', 
                shadow: '0 0 15px rgba(239, 68, 68, 0.4)', 
                textColor: '#dc2626',
                bgColor: 'rgba(239, 68, 68, 0.1)'
              }
            };
            
            const colors = colorMap[performanceClass];
            if (colors) {
              card.style.border = `3px solid ${colors.border}`;
              card.style.boxShadow = colors.shadow;
              card.style.backgroundColor = colors.bgColor;
              
              const valueElement = card.querySelector('.value');
              if (valueElement) {
                originalValueStyles.push({
                  element: valueElement,
                  color: valueElement.style.color
                });
                valueElement.style.color = colors.textColor;
              }
              
              const rankBadge = card.querySelector('.rank-badge');
              if (rankBadge) {
                originalRankBadgeStyles.push({
                  element: rankBadge,
                  position: rankBadge.style.position,
                  transform: rankBadge.style.transform,
                  marginTop: rankBadge.style.marginTop,
                  marginBottom: rankBadge.style.marginBottom,
                  background: rankBadge.style.background,
                  backgroundColor: rankBadge.style.backgroundColor,
                  border: rankBadge.style.border,
                  borderWidth: rankBadge.style.borderWidth,
                  borderStyle: rankBadge.style.borderStyle,
                  borderColor: rankBadge.style.borderColor,
                  borderRadius: rankBadge.style.borderRadius,
                  padding: rankBadge.style.padding,
                  color: rankBadge.style.color,
                  fontWeight: rankBadge.style.fontWeight
                });
                rankBadge.style.position = 'relative';
                rankBadge.style.transform = 'none';
                rankBadge.style.marginTop = '0.3rem';
                rankBadge.style.marginBottom = '0';
                rankBadge.style.background = 'transparent';
                rankBadge.style.backgroundColor = 'transparent';
                rankBadge.style.border = 'none';
                rankBadge.style.borderWidth = '0';
                rankBadge.style.borderStyle = 'none';
                rankBadge.style.borderColor = 'transparent';
                rankBadge.style.borderRadius = '0';
                rankBadge.style.padding = '0';
                rankBadge.style.color = '#374151';
                rankBadge.style.fontWeight = '600';
              }
            }
          }
        });
        
        // הסתר את כל ה-::before gradients עם style element אחד
        const hideGradientsStyle = document.createElement('style');
        hideGradientsStyle.textContent = `
          .neon-card::before { display: none !important; }
          .neon-card::after { display: none !important; }
        `;
        document.head.appendChild(hideGradientsStyle);
        styleElements.push(hideGradientsStyle);
        
        // כפיית רקע לבן רק על הלגנדה (מצטיין, טוב, ממוצע) - לא על העיגולים
        const legendContainer = returnsSection.querySelector('[class*="bg-gradient-to-br"][class*="from-blue-50"]');
        
        if (legendContainer) {
          originalBackgrounds.push({
            element: legendContainer,
            background: legendContainer.style.background,
            backgroundColor: legendContainer.style.backgroundColor,
            backgroundImage: legendContainer.style.backgroundImage
          });
          legendContainer.style.background = 'white';
          legendContainer.style.backgroundColor = 'white';
          legendContainer.style.backgroundImage = 'none';
          
          // גם על כל האלמנטים בתוך הלגנדה
          const legendElements = legendContainer.querySelectorAll('*');
          legendElements.forEach(el => {
            const computedStyle = window.getComputedStyle(el);
            const bgImage = computedStyle.backgroundImage;
            const bgColor = computedStyle.backgroundColor;
            
            // אם יש gradient או רקע צבעוני, החלף ללבן
            if ((bgImage && bgImage !== 'none' && bgImage.includes('gradient')) || 
                (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent' && bgColor !== 'rgba(255, 255, 255, 1)' && bgColor !== 'rgb(255, 255, 255)')) {
              originalBackgrounds.push({
                element: el,
                background: el.style.background,
                backgroundColor: el.style.backgroundColor,
                backgroundImage: el.style.backgroundImage
              });
              el.style.background = 'white';
              el.style.backgroundColor = 'white';
              el.style.backgroundImage = 'none';
            }
          });
        }
        
        // גם על ה-ReturnsSection עצמו - ודא שהרקע לבן
        const returnsSectionBg = window.getComputedStyle(returnsSection).backgroundColor;
        const returnsSectionBgImage = window.getComputedStyle(returnsSection).backgroundImage;
        if (returnsSectionBgImage && returnsSectionBgImage !== 'none' && returnsSectionBgImage.includes('gradient')) {
          originalBackgrounds.push({
            element: returnsSection,
            background: returnsSection.style.background,
            backgroundColor: returnsSection.style.backgroundColor,
            backgroundImage: returnsSection.style.backgroundImage
          });
          returnsSection.style.background = 'white';
          returnsSection.style.backgroundColor = 'white';
          returnsSection.style.backgroundImage = 'none';
        }
        
        // גם על כל האלמנטים האחרים חוץ מהעיגולים והלגנדה
        const allElements = returnsSection.querySelectorAll('*');
        
        allElements.forEach(el => {
          // דלג על העיגולים (neon-card) והלגנדה
          if (el.classList.contains('neon-card') || el.closest('.neon-card') || el === legendContainer || el.closest('[class*="bg-gradient-to-br"][class*="from-blue-50"]')) {
            return;
          }
          
          const computedStyle = window.getComputedStyle(el);
          const bgImage = computedStyle.backgroundImage;
          const bgColor = computedStyle.backgroundColor;
          
          // אם יש gradient או רקע צבעוני, החלף ללבן
          if ((bgImage && bgImage !== 'none' && bgImage.includes('gradient')) || 
              (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent' && bgColor !== 'rgba(255, 255, 255, 1)' && bgColor !== 'rgb(255, 255, 255)')) {
            originalBackgrounds.push({
              element: el,
              background: el.style.background,
              backgroundColor: el.style.backgroundColor,
              backgroundImage: el.style.backgroundImage
            });
            el.style.background = 'white';
            el.style.backgroundColor = 'white';
            el.style.backgroundImage = 'none';
          }
          
          // הגדל את הטקסט "מצטיין טוב ממוצע" מתחת לעיגולים
          if (el.tagName === 'SPAN' && el.textContent && 
              (el.textContent.trim() === 'מצטיין' || el.textContent.trim() === 'טוב' || 
               el.textContent.trim() === 'ממוצע' || el.textContent.trim() === 'מתחת לממוצע' || 
               el.textContent.trim() === 'חלש')) {
            const parent = el.parentElement;
            if (parent && parent.classList.contains('text-center')) {
              originalPerformanceLabelStyles.push({
                element: el,
                fontSize: el.style.fontSize,
                fontWeight: el.style.fontWeight
              });
              el.style.fontSize = '1rem';
              el.style.fontWeight = '600';
            }
          }
        });
      });
      
      // הסתר כפתורים
      const hiddenElements = [];
      returnsContainers.forEach(container => {
        const buttons = container.querySelectorAll('button');
        buttons.forEach(btn => {
          hiddenElements.push({ element: btn, visibility: btn.style.visibility });
          btn.style.visibility = 'hidden';
        });
      });
      
      // המתן קצת לפני הצילום
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // צילום של כל הקונטיינר (כל 3 הדפים יחד)
      const canvas = await html2canvas(allPagesContainer, {
        backgroundColor: '#ffffff',
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        width: 1200,
        windowWidth: 1200,
        height: allPagesContainer.scrollHeight,
        windowHeight: allPagesContainer.scrollHeight
      });
      
      // החזר את כל האלמנטים למצב המקורי
      hiddenElements.forEach(({ element, visibility }) => {
        if (visibility !== undefined) element.style.visibility = visibility;
      });
      
      // החזר רקעים מקוריים
      originalBackgrounds.forEach(({ element, background, backgroundColor, backgroundImage }) => {
        element.style.background = background || '';
        element.style.backgroundColor = backgroundColor || '';
        element.style.backgroundImage = backgroundImage || '';
      });
      
      // החזר צבעי כותרות
      originalTitleStyles.forEach(({ element, color, background, webkitBackgroundClip, backgroundClip, webkitTextFillColor, className }) => {
        element.style.color = color || '';
        element.style.background = background || '';
        element.style.webkitBackgroundClip = webkitBackgroundClip || '';
        element.style.backgroundClip = backgroundClip || '';
        element.style.webkitTextFillColor = webkitTextFillColor || '';
        element.className = className || '';
      });
      
      // החזר גודל פונט של הטקסט "מצטיין טוב ממוצע"
      originalPerformanceLabelStyles.forEach(({ element, fontSize, fontWeight }) => {
        element.style.fontSize = fontSize || '';
        element.style.fontWeight = fontWeight || '';
      });
      
      // החזר צבעי עיגולים
      originalCardStyles.forEach(({ element, border, borderWidth, borderStyle, borderColor, boxShadow, background, backgroundColor }) => {
        element.style.border = border || '';
        element.style.borderWidth = borderWidth || '';
        element.style.borderStyle = borderStyle || '';
        element.style.borderColor = borderColor || '';
        element.style.boxShadow = boxShadow || '';
        element.style.background = background || '';
        element.style.backgroundColor = backgroundColor || '';
      });
      
      // החזר צבעי טקסט בעיגולים
      originalValueStyles.forEach(({ element, color }) => {
        element.style.color = color || '';
      });
      
      // החזר סגנונות rank-badge
      originalRankBadgeStyles.forEach(({ element, position, transform, marginTop, marginBottom, background, backgroundColor, border, borderWidth, borderStyle, borderColor, borderRadius, padding, color, fontWeight }) => {
        element.style.position = position || '';
        element.style.transform = transform || '';
        element.style.marginTop = marginTop || '';
        element.style.marginBottom = marginBottom || '';
        element.style.background = background || '';
        element.style.backgroundColor = backgroundColor || '';
        element.style.border = border || '';
        element.style.borderWidth = borderWidth || '';
        element.style.borderStyle = borderStyle || '';
        element.style.borderColor = borderColor || '';
        element.style.borderRadius = borderRadius || '';
        element.style.padding = padding || '';
        element.style.color = color || '';
        element.style.fontWeight = fontWeight || '';
      });
      
      // הסר את כל ה-style elements
      styleElements.forEach(styleEl => {
        if (styleEl.parentNode) {
          styleEl.parentNode.removeChild(styleEl);
        }
      });

      // הורדה של תמונה אחת עם כל 3 הדפים
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const fund1Name = getDisplayName(fund1Data);
        const fund2Name = getDisplayName(fund2Data);
        const fileName = `השוואה_מלאה_${fund1Name}_${fund2Name}_${new Date().toISOString().split('T')[0]}.png`;
        
        link.href = url;
        link.download = fileName;
        link.click();
        
        URL.revokeObjectURL(url);
      });

      // ניקוי סופי - בטל את כל ה-roots
      rootsToCleanup.forEach(({ root }) => {
        try {
          root.unmount();
        } catch (e) {
          // כבר בוטל
        }
      });
      
      document.body.removeChild(tempContainer);
      
      setShareMessage('כל 3 התמונות הורדו!');
      setTimeout(() => setShareMessage(''), 3000);

    } catch (error) {
      console.error('Error exporting images:', error);
      alert('אירעה שגיאה בהורדת התמונות');
      setShareMessage('');
    }
  };

  // פונקציה לחישוב דירוגים לפי קבוצת הקרנות (כמו ReturnsSection)
  const computeRankingsForFund = async (fund, spec, category, fundId) => {
    if (!spec?.fundIds?.length) return {};
    try {
      const allProducts = await api.getProducts(category);
      let groupProducts = allProducts.filter(p => spec.fundIds.includes(parseInt(p.id)));
      const foundIds = groupProducts.map(p => parseInt(p.id));
      const missingIds = spec.fundIds.filter(id => !foundIds.includes(parseInt(id)));
      for (const missingId of missingIds) {
        try {
          const p = await api.getProductById(missingId.toString(), category);
          if (p) groupProducts.push(p);
        } catch (e) { /* ignore */ }
      }
      const periods = ['month1', 'ytd', 'year1', 'year2', 'year3', 'year4', 'year5'];
      const rankings = {};
      periods.forEach(period => {
        const valid = groupProducts.filter(p => p.returns?.[period] != null && !isNaN(p.returns[period]));
        if (valid.length === 0) { rankings[period] = null; return; }
        const sorted = [...valid].sort((a, b) => (b.returns[period] || 0) - (a.returns[period] || 0));
        const idx = sorted.findIndex(p => parseInt(p.id) === parseInt(fundId));
        if (idx !== -1) rankings[period] = { rank: idx + 1, total: valid.length };
        else rankings[period] = null;
      });
      return rankings;
    } catch (e) {
      return {};
    }
  };

  const getPerformanceLabel = (ranking) => {
    if (!ranking?.rank) return '-';
    const r = ranking.rank;
    if (r <= 2) return 'מצטיין';
    if (r <= 4) return 'טוב';
    if (r <= 6) return 'ממוצע';
    if (r <= 8) return 'מתחת לממוצע';
    return 'חלש';
  };

  const getRankPosition = (ranking) => {
    if (!ranking?.rank || !ranking?.total) return '-';
    return `מקום ${ranking.rank}/${ranking.total}`;
  };

  // פונקציה לייצוא PDF - עמוד 1: טבלת פרטים (סגנון סורק המסלולים) | עמוד 2: ניתוח AI
  const exportAll3PagesAsPDF = async () => {
    if (!currentFundId || !selectedFund?.id) {
      alert('אנא בחר קרן להשוואה');
      return;
    }

    if (!analysisRef.current || !smartAnalysis) {
      alert('אנא הפעל ניתוח AI קודם');
      return;
    }

    let tempContainer = null;
    try {
      setShareMessage('מייצא PDF...');
      
      const fund1Data = currentFundData || await api.getProductById(currentFundId, category);
      const fund2Data = selectedFund || await api.getProductById(selectedFund.id, category);

      const [spec1, spec2] = await Promise.all([
        matchingSpecialization || getEnhancedSpecializationMatch(fund1Data, category, api),
        getEnhancedSpecializationMatch(fund2Data, category, api)
      ]);

      // חישוב דירוגים לשתי הקרנות
      const [rankings1, rankings2] = await Promise.all([
        computeRankingsForFund(fund1Data, spec1, category, currentFundId),
        computeRankingsForFund(fund2Data, spec2, category, selectedFund.id)
      ]);

      const formatVal = (v, decimals = 2) => {
        if (v == null || isNaN(v)) return '-';
        return `${parseFloat(v).toFixed(decimals)}%`;
      };

      // שורות הטבלה: תשואות + חשיפות
      const tableRows = [
        { key: 'month1', label: 'חודש אחרון', field: 'returns.month1', higherBetter: true },
        { key: 'ytd', label: 'מתחילת שנה', field: 'returns.ytd', higherBetter: true },
        { key: 'year1', label: 'שנה אחרונה', field: 'returns.year1', higherBetter: true },
        { key: 'year2', label: 'שנתיים', field: 'returns.year2', higherBetter: true },
        { key: 'year3', label: '3 שנים', field: 'returns.year3', higherBetter: true },
        { key: 'year4', label: '4 שנים', field: 'returns.year4', higherBetter: true },
        { key: 'year5', label: '5 שנים', field: 'returns.year5', higherBetter: true },
        { key: 'stocks', label: 'חשיפה למניות', field: 'exposures.stocks', higherBetter: true },
        { key: 'currency', label: 'חשיפה למט״ח', field: 'exposures.currency', higherBetter: false },
        { key: 'illiquid', label: 'נכסים לא סחירים', field: 'illiquid', higherBetter: false }
      ];

      const getNested = (obj, path) => {
        if (path === 'illiquid') {
          const pct = obj.performance?.liquidAssetsPercent;
          return pct != null ? (100 - pct) : null;
        }
        return path.split('.').reduce((c, k) => c?.[k], obj);
      };

      const isBetter = (v1, v2, higherBetter) => {
        if (v1 == null || isNaN(v1)) return false;
        if (v2 == null || isNaN(v2)) return true;
        return higherBetter ? v1 > v2 : v1 < v2;
      };

      // יצירת container זמני
      tempContainer = document.createElement('div');
      tempContainer.style.cssText = 'position: fixed; left: -9999px; top: 0; width: 1200px; background: white; z-index: -1;';
      document.body.appendChild(tempContainer);

      const allPagesContainer = document.createElement('div');
      allPagesContainer.style.cssText = 'width: 1200px; background: white; direction: rtl !important; white-space: normal !important;';
      allPagesContainer.setAttribute('dir', 'rtl');
      tempContainer.appendChild(allPagesContainer);

      const pageContainers = [];

      // ========== עמוד 1: טבלת פרטים (עיצוב משופר) ==========
      const fund1DisplayName = getDisplayName(fund1Data);
      const fund2DisplayName = getDisplayName(fund2Data);

      const page1Div = document.createElement('div');
      page1Div.style.cssText = 'width: 1200px; background: #fafafa; padding: 24px; direction: rtl; page-break-after: always;';
      page1Div.setAttribute('dir', 'rtl');

      const tableTitle = document.createElement('h2');
      tableTitle.style.cssText = 'margin: 0 0 6px 0; font-size: 18px; font-weight: 700; color: #1f2937; text-align: center;';
      tableTitle.textContent = 'השוואה';
      page1Div.appendChild(tableTitle);

      const tableSubtitle = document.createElement('p');
      tableSubtitle.style.cssText = 'margin: 0 0 16px 0; font-size: 13px; color: #6b7280; text-align: center;';
      tableSubtitle.textContent = `${fund1DisplayName} מול ${fund2DisplayName}`;
      page1Div.appendChild(tableSubtitle);

      const tableWrapper = document.createElement('div');
      tableWrapper.style.cssText = 'background: white; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); overflow: hidden; border: 1px solid #e5e7eb;';
      tableWrapper.setAttribute('dir', 'rtl');

      const table = document.createElement('table');
      table.style.cssText = 'width: 100%; border-collapse: collapse; font-family: inherit; font-size: 12px;';
      table.setAttribute('dir', 'rtl');

      const thead = document.createElement('thead');
      thead.style.cssText = 'background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);';
      const headerRow = document.createElement('tr');
      ['פרמטר', fund1DisplayName, fund2DisplayName, 'דירוג'].forEach((text, i) => {
        const th = document.createElement('th');
        th.style.cssText = 'padding: 12px 16px; text-align: right; font-size: 12px; font-weight: 600; color: #374151; border-left: 1px solid #e2e8f0;';
        if (i === 1 || i === 2) {
          th.innerHTML = `<div style="display:flex;flex-direction:column;gap:3px;text-align:center;">
            <span style="font-weight:600;color:#1e293b;">${text}</span>
            <span style="font-size:11px;color:#64748b;">${(i === 1 ? fund1Data : fund2Data).company || '-'}</span>
            <span style="font-size:10px;color:#3b82f6;font-family:monospace;">מספר באוצר: ${(i === 1 ? fund1Data : fund2Data).id || '-'}</span>
          </div>`;
        } else {
          th.textContent = text;
        }
        headerRow.appendChild(th);
      });
      thead.appendChild(headerRow);
      table.appendChild(thead);

      const tbody = document.createElement('tbody');

      tableRows.forEach((row, idx) => {
        const v1 = row.key === 'illiquid' ? getNested(fund1Data, 'illiquid') : getNested(fund1Data, row.field);
        const v2 = row.key === 'illiquid' ? getNested(fund2Data, 'illiquid') : getNested(fund2Data, row.field);
        const disp1 = row.key.startsWith('returns') || row.key === 'stocks' || row.key === 'currency' || row.key === 'illiquid' ? formatVal(v1) : (v1 ?? '-');
        const disp2 = row.key.startsWith('returns') || row.key === 'stocks' || row.key === 'currency' || row.key === 'illiquid' ? formatVal(v2) : (v2 ?? '-');
        const better1 = isBetter(v1, v2, row.higherBetter);
        const better2 = isBetter(v2, v1, row.higherBetter);
        const isExposure = row.key === 'stocks' || row.key === 'currency' || row.key === 'illiquid';
        const r1 = !isExposure ? rankings1[row.key] : null;
        const r2 = !isExposure ? rankings2[row.key] : null;

        let rankContent;
        if (isExposure) {
          if (better1 && !better2) rankContent = `${fund1DisplayName} עדיפה`;
          else if (better2 && !better1) rankContent = `${fund2DisplayName} עדיפה`;
          else rankContent = 'תיקו';
        } else {
          const pos1 = getRankPosition(r1);
          const pos2 = getRankPosition(r2);
          const label1 = getPerformanceLabel(r1);
          const label2 = getPerformanceLabel(r2);
          rankContent = `<div style="display:flex;flex-direction:column;gap:1px;font-size:11px;">
            <span>קרן 1: ${pos1} (${label1})</span>
            <span>קרן 2: ${pos2} (${label2})</span>
          </div>`;
        }

        const tr = document.createElement('tr');
        tr.style.cssText = idx % 2 === 0 ? 'background: #fff;' : 'background: #fafafa;';
        tr.style.borderBottom = '1px solid #eee';

        const tdParam = document.createElement('td');
        tdParam.style.cssText = 'padding: 8px 14px; font-size: 12px; font-weight: 500; color: #4b5563; border-left: 1px solid #e8e8e8;';
        tdParam.textContent = row.label;
        tr.appendChild(tdParam);

        const td1 = document.createElement('td');
        td1.style.cssText = `padding: 8px 14px; font-size: 12px; text-align: center; border-left: 1px solid #e8e8e8; ${better1 ? 'background: #ecfdf5; color: #047857; font-weight: 600;' : 'color: #4b5563;'}`;
        td1.textContent = disp1;
        tr.appendChild(td1);

        const td2 = document.createElement('td');
        td2.style.cssText = `padding: 8px 14px; font-size: 12px; text-align: center; border-left: 1px solid #e8e8e8; ${better2 ? 'background: #ecfdf5; color: #047857; font-weight: 600;' : 'color: #4b5563;'}`;
        td2.textContent = disp2;
        tr.appendChild(td2);

        const tdRank = document.createElement('td');
        tdRank.style.cssText = 'padding: 8px 14px; font-size: 11px; text-align: center; border-left: 1px solid #e8e8e8; color: #4b5563;';
        tdRank.innerHTML = rankContent;
        tr.appendChild(tdRank);

        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      tableWrapper.appendChild(table);
      page1Div.appendChild(tableWrapper);
      allPagesContainer.appendChild(page1Div);
      pageContainers.push(page1Div);

      // ========== עמוד 2: ניתוח AI (כמו באתר - יתרונות/חסרונות של המנצחת + דמי ניהול) ==========
      const page2Div = document.createElement('div');
      page2Div.style.cssText = 'width: 1100px; background: #fafafa; padding: 20px 24px; direction: rtl; font-size: 11px; line-height: 1.5; color: #374151;';
      page2Div.setAttribute('dir', 'rtl');

      const { currentFundName, selectedFundName, currentFundWins, selectedFundWins, totalPeriods, actualWinner, performanceComparison, feeComparison, depositFeeComparison } = smartAnalysis;

      // כותרת עם VS (כמו באתר)
      const vsHeader = document.createElement('div');
      vsHeader.style.cssText = 'display: flex; align-items: center; justify-content: center; gap: 24px; margin-bottom: 16px; padding: 14px 20px; background: linear-gradient(90deg, #4f46e5 0%, #7c3aed 50%, #4f46e5 100%); border-radius: 10px; color: white;';
      vsHeader.innerHTML = `
        <div style="flex:1;text-align:center;">
          <div style="font-size:11px;font-weight:600;opacity:0.9;margin-bottom:4px;">${currentFundName}</div>
          <div style="font-size:22px;font-weight:800;">${currentFundWins}</div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:center;padding:0 12px;">
          <div style="font-size:14px;font-weight:800;">-</div>
          <div style="font-size:10px;opacity:0.8;">VS</div>
          <div style="width:20px;height:1px;background:rgba(255,255,255,0.4);margin-top:4px;"></div>
        </div>
        <div style="flex:1;text-align:center;">
          <div style="font-size:11px;font-weight:600;opacity:0.9;margin-bottom:4px;">${selectedFundName}</div>
          <div style="font-size:22px;font-weight:800;">${selectedFundWins}</div>
        </div>
      `;
      page2Div.appendChild(vsHeader);

      const addSection = (title, subtitle, items, isAdvantage) => {
        if (!items || items.length === 0) return;
        const section = document.createElement('div');
        section.style.cssText = 'margin-bottom: 14px;';
        const titleEl = document.createElement('h6');
        titleEl.style.cssText = `margin: 0 0 6px 0; font-size: 12px; font-weight: 700; color: ${isAdvantage ? '#166534' : '#b91c1c'};`;
        titleEl.textContent = title;
        section.appendChild(titleEl);
        const subEl = document.createElement('p');
        subEl.style.cssText = `margin: 0 0 8px 0; font-size: 11px; color: ${isAdvantage ? '#15803d' : '#dc2626'};`;
        subEl.textContent = subtitle;
        section.appendChild(subEl);
        items.forEach(p => {
          const box = document.createElement('div');
          box.style.cssText = `margin: 6px 0; padding: 8px 10px; border-radius: 6px; font-size: 11px; background: ${isAdvantage ? '#f0fdf4' : '#fef2f2'}; border: 1px solid ${isAdvantage ? '#bbf7d0' : '#fecaca'};`;
          const winnerVal = actualWinner === 'current' ? p.currentReturn : p.selectedReturn;
          const loserVal = actualWinner === 'current' ? p.selectedReturn : p.currentReturn;
          const winnerName = actualWinner === 'current' ? currentFundName : selectedFundName;
          const loserName = actualWinner === 'current' ? selectedFundName : currentFundName;
          let html = `תשואה מצטברת ${p.period}: ${winnerVal}% ב${winnerName} לעומת ${loserVal}% ב${loserName}`;
          const winnerAvg = actualWinner === 'current' ? p.currentAnnualAvg : p.selectedAnnualAvg;
          const loserAvg = actualWinner === 'current' ? p.selectedAnnualAvg : p.currentAnnualAvg;
          if (winnerAvg != null && loserAvg != null && p.years) {
            const months = p.years * 12;
            html += `<div style="margin-top:4px;font-size:10px;color:#6b7280;font-style:italic;">תשואה ממוצעת לכל שנה ב${months} החודשים האחרונים: ${Number(winnerAvg).toFixed(2)}% ב${winnerName} | ${Number(loserAvg).toFixed(2)}% ב${loserName}</div>`;
          }
          box.innerHTML = html;
          section.appendChild(box);
        });
        page2Div.appendChild(section);
      };

      if (actualWinner === 'current') {
        const winningPeriods = performanceComparison?.filter(p => p.currentWins) || [];
        const losingPeriods = performanceComparison?.filter(p => !p.currentWins) || [];
        addSection(`יתרונות ב${currentFundName} (המנצחת):`, 'ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:', winningPeriods, true);
        addSection(losingPeriods.length === 1 ? `חיסרון ב${currentFundName} (המנצחת):` : `חסרונות ב${currentFundName} (המנצחת):`, 'ביצועים נמוכים יותר בתשואה שנתית נומינלית ברוטו:', losingPeriods, false);
      } else if (actualWinner === 'selected') {
        const winningPeriods = performanceComparison?.filter(p => !p.currentWins) || [];
        const losingPeriods = performanceComparison?.filter(p => p.currentWins) || [];
        addSection(`יתרונות ב${selectedFundName} (המנצחת):`, 'ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:', winningPeriods, true);
        addSection(losingPeriods.length === 1 ? `חיסרון ב${selectedFundName} (המנצחת):` : `חסרונות ב${selectedFundName} (המנצחת):`, 'ביצועים נמוכים יותר בתשואה שנתית נומינלית ברוטו:', losingPeriods, false);
      } else {
        const currentWins = performanceComparison?.filter(p => p.currentWins) || [];
        const selectedWins = performanceComparison?.filter(p => !p.currentWins) || [];
        addSection(`יתרונות ב${currentFundName}:`, 'ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:', currentWins, true);
        addSection(`יתרונות ב${selectedFundName}:`, 'ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:', selectedWins, true);
      }

      // דמי ניהול - כמו באתר
      if (feeComparison) {
        const feeSection = document.createElement('div');
        feeSection.style.cssText = 'margin-top: 14px;';
        if (feeComparison.isEqual) {
          feeSection.innerHTML = `<h6 style="margin:0 0 6px 0;font-size:12px;font-weight:700;color:#1e40af;">דמי ניהול זהים:</h6><div style="padding:8px 10px;background:#eff6ff;border-radius:6px;border:1px solid #bfdbfe;font-size:11px;">דמי ניהול מהחיסכון זהים בשתי הקרנות - ${feeComparison.currentFee}%</div>`;
        } else {
          const feeWinnerName = feeComparison.currentHasAdvantage ? currentFundName : selectedFundName;
          const feeLoserName = feeComparison.currentHasAdvantage ? selectedFundName : currentFundName;
          const lowerFee = feeComparison.currentHasAdvantage ? feeComparison.currentFee : feeComparison.selectedFee;
          const higherFee = feeComparison.currentHasAdvantage ? feeComparison.selectedFee : feeComparison.currentFee;
          const feeTitle = actualWinner === 'tie' ? `יתרון בדמי ניהול ל${feeWinnerName}:` :
            (actualWinner === 'current' ? (feeWinnerName === currentFundName ? `יתרון נוסף ב${currentFundName} (המנצחת):` : `חיסרון ב${currentFundName} (המנצחת):`) :
              (feeWinnerName === selectedFundName ? `יתרון נוסף ב${selectedFundName} (המנצחת):` : `חיסרון ב${selectedFundName} (המנצחת):`));
          const feeColor = feeWinnerName === (actualWinner === 'current' ? currentFundName : selectedFundName) ? '#166534' : '#b91c1c';
          feeSection.innerHTML = `<h6 style="margin:0 0 6px 0;font-size:12px;font-weight:700;color:${feeColor};">${feeTitle}</h6><div style="padding:8px 10px;background:${feeColor === '#166534' ? '#f0fdf4' : '#fef2f2'};border-radius:6px;border:1px solid ${feeColor === '#166534' ? '#bbf7d0' : '#fecaca'};font-size:11px;">דמי ניהול מהחיסכון נמוכים יותר ${lowerFee}% ב${feeWinnerName} לעומת ${higherFee}% ב${feeLoserName}</div>`;
        }
        page2Div.appendChild(feeSection);
      }

      // דמי ניהול מהפקדה (פנסיה) - כמו באתר
      if (isPensionFund() && depositFeeComparison) {
        const depSection = document.createElement('div');
        depSection.style.cssText = 'margin-top: 14px;';
        if (depositFeeComparison.isEqual) {
          depSection.innerHTML = `<h6 style="margin:0 0 6px 0;font-size:12px;font-weight:700;color:#1e40af;">דמי ניהול מהפקדה זהים:</h6><div style="padding:8px 10px;background:#eff6ff;border-radius:6px;border:1px solid #bfdbfe;font-size:11px;">דמי ניהול מהפקדה זהים בשתי הקרנות - ${depositFeeComparison.currentDepositFee}%</div>`;
        } else {
          const depWinnerName = depositFeeComparison.currentHasAdvantage ? currentFundName : selectedFundName;
          const depLoserName = depositFeeComparison.currentHasAdvantage ? selectedFundName : currentFundName;
          const lowerDep = depositFeeComparison.currentHasAdvantage ? depositFeeComparison.currentDepositFee : depositFeeComparison.selectedDepositFee;
          const higherDep = depositFeeComparison.currentHasAdvantage ? depositFeeComparison.selectedDepositFee : depositFeeComparison.currentDepositFee;
          const perfWinnerName = actualWinner === 'current' ? currentFundName : selectedFundName;
          const depTitle = actualWinner === 'tie' ? `יתרון בדמי ניהול מהפקדה ל${depWinnerName}:` :
            (depWinnerName === perfWinnerName ? `יתרון נוסף בדמי ניהול מהפקדה ב${perfWinnerName}:` : `חיסרון בדמי ניהול מהפקדה ב${perfWinnerName} (המנצחת):`);
          const depColor = depWinnerName === perfWinnerName ? '#166534' : '#b91c1c';
          depSection.innerHTML = `<h6 style="margin:0 0 6px 0;font-size:12px;font-weight:700;color:${depColor};">${depTitle}</h6><div style="padding:8px 10px;background:${depColor === '#166534' ? '#f0fdf4' : '#fef2f2'};border-radius:6px;border:1px solid ${depColor === '#166534' ? '#bbf7d0' : '#fecaca'};font-size:11px;">דמי ניהול מהפקדה נמוכים יותר ${lowerDep}% ב${depWinnerName} לעומת ${higherDep}% ב${depLoserName}</div>`;
        }
        page2Div.appendChild(depSection);
      }

      allPagesContainer.appendChild(page2Div);
      pageContainers.push(page2Div);

      await new Promise(resolve => setTimeout(resolve, 800));

      // הסתרת הודעת "מייצא PDF..." לפני הצילום
      const shareMessageElements = allPagesContainer.querySelectorAll('span.text-green-600, span.text-green-500');
      shareMessageElements.forEach(el => {
        const text = el.textContent || '';
        if (text.trim() === 'מייצא PDF...' || text.trim().includes('מייצא PDF')) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.height = '0';
          el.style.margin = '0';
          el.style.padding = '0';
        }
      });

      // צילום כל עמוד בנפרד - html2canvas
      const pageImages = [];
      for (let i = 0; i < pageContainers.length; i++) {
        const pageDiv = pageContainers[i];
        const canvas = await html2canvas(pageDiv, {
          backgroundColor: '#ffffff',
          scale: 1,
          logging: false,
          useCORS: true,
          allowTaint: false,
          width: pageDiv.offsetWidth || 1200,
          windowWidth: pageDiv.offsetWidth || 1200,
          height: pageDiv.scrollHeight,
          windowHeight: pageDiv.scrollHeight,
          onclone: (clonedDoc) => {
            const allElements = clonedDoc.querySelectorAll('*');
            allElements.forEach(el => {
              el.setAttribute('dir', 'rtl');
              el.style.direction = 'rtl';
              el.style.whiteSpace = 'normal';
              el.style.wordSpacing = 'normal';
              el.style.letterSpacing = 'normal';
            });
            const greenTextElements = clonedDoc.querySelectorAll('span.text-green-600, span.text-green-500');
            greenTextElements.forEach(el => {
              const text = el.textContent || '';
              if (text.trim() === 'מייצא PDF...' || text.trim().includes('מייצא PDF')) {
                el.style.display = 'none';
                el.style.visibility = 'hidden';
                el.style.opacity = '0';
                el.style.height = '0';
                el.style.margin = '0';
                el.style.padding = '0';
              }
            });
          }
        });
        if (canvas && canvas.width > 0 && canvas.height > 0) {
          pageImages.push(canvas.toDataURL('image/png', 0.95));
        }
      }

      
      // יצירת HTML להדפסה עם כל העמודים - כמו ב-CompactComparisonTable
      const fund1NameForPDF = getDisplayName(fund1Data);
      const fund2NameForPDF = getDisplayName(fund2Data);
      
      const imagesHTML = pageImages.map((imgData, index) => {
        // כל עמוד חוץ מהאחרון צריך page-break
        const pageBreakClass = index < pageImages.length - 1 ? 'page-break' : '';
        return `<div class="${pageBreakClass}"><img src="${imgData}" alt="עמוד ${index + 1}" style="width: 100%; height: auto; max-height: 100%; object-fit: contain; display: block;" /></div>`;
      }).join('');
      
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('אנא אפשר חלונות קופצים להדפסה');
        return;
      }
      
      printWindow.document.write(`
        <!DOCTYPE html>
        <html dir="rtl" lang="he">
        <head>
          <meta charset="utf-8">
          <title>השוואה מלאה - ${fund1NameForPDF} vs ${fund2NameForPDF}</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 10mm;
            }
            @media print {
              @page {
                margin: 0;
              }
              body {
                margin: 0;
                padding: 0;
              }
            }
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              direction: rtl;
              background: white;
            }
            img {
              max-width: 100%;
              max-height: 100%;
              height: auto;
              display: block;
              page-break-inside: avoid;
              object-fit: contain;
            }
            .page-break {
              page-break-after: always;
              page-break-inside: avoid;
            }
            .page-break:last-child {
              page-break-after: auto;
            }
            div {
              page-break-inside: avoid;
            }
            .links-footer {
              margin-top: 5px;
              padding: 5px 0;
              font-size: 0.65rem;
              line-height: 1.2;
              direction: rtl;
              page-break-inside: avoid;
            }
            .links-footer h3 {
              font-size: 0.75rem;
              font-weight: bold;
              margin: 2px 0;
              color: #111827;
            }
            .links-footer a {
              color: #2563eb;
              text-decoration: underline;
              margin: 0 3px;
            }
            .disclaimer-footer {
              margin-top: 3px;
              padding-top: 3px;
              font-size: 0.6rem;
              line-height: 1.2;
              color: #4b5563;
            }
            .disclaimer-footer h3 {
              font-size: 0.7rem;
              font-weight: bold;
              margin: 2px 0;
              color: #374151;
            }
            .disclaimer-footer p {
              margin: 1px 0;
            }
          </style>
        </head>
        <body>
          ${imagesHTML}
          <div class="links-footer">
            <h3>קישורים נוספים</h3>
            <div>
              <a href="${window.location.origin}/product/${category}/${currentFundId}">קישור לקרן 1: ${fund1NameForPDF}</a> | 
              <a href="${window.location.origin}/product/${category}/${selectedFund.id}">קישור לקרן 2: ${fund2NameForPDF}</a>
            </div>
            <div class="disclaimer-footer">
              <h3>⚠️ הבהרה משפטית</h3>
              <p>📊 המידע באתר גמל נט AI נועד להנגיש תובנות והשוואות, אך אינו מהווה ייעוץ פנסיוני, פיננסי או השקעות. 📄✅ כל החלטה צריכה להיעשות תוך התאמה אישית ובליווי בעל רישיון מוסמך בלבד. ⏳ תשואות עבר אינן מעידות בהכרח על ביצועים עתידיים, ואין לראות בנתונים באתר התחייבות או המלצה. 🧠 אנו עושים מאמץ כנה בשילוב מערכות בינה מלאכותית מתקדמות לספק מידע מדויק, אך האחריות לשימוש בו ולפרשנותו היא בידי המשתמש בלבד.</p>
            </div>
          </div>
        </body>
        </html>
      `);
      
      printWindow.document.close();
      
      // המתן לטעינת התמונות ואז הדפס
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          printWindow.onafterprint = () => {
            printWindow.close();
          };
        }, 500);
      };

      // ניקוי
      if (tempContainer?.parentNode) {
        document.body.removeChild(tempContainer);
      }
      
      setShareMessage('פתח חלון הדפסה...');
      setTimeout(() => setShareMessage(''), 3000);

    } catch (error) {
      console.error('Error exporting PDF:', error);
      alert('אירעה שגיאה בהורדת ה-PDF');
      setShareMessage('');
      if (tempContainer?.parentNode) {
        document.body.removeChild(tempContainer);
      }
    }
  };

  if (!currentFundData) return null;

return (
 <div className={`bg-white rounded-xl shadow-md border border-gray-100 p-4 md:p-6 font-bold ${className}`}>
      
<h3 className="text-sm md:text-xl font-bold text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
  <BarChart3 className="h-5 w-5 md:h-6 md:w-6 text-purple-600" />
השוואה מהירה בין 2 קרנות ברמת סיכון {currentFundData.riskLevel.level} מתוך 5
  {/* כפתור הטולטיפ */}
  <button
    ref={tooltipRef}
    onMouseEnter={() => {
      if (!isMobile) {
        setShowTooltip(true);
      }
    }}
    onMouseLeave={() => {
      if (!isMobile) {
        setShowTooltip(false);
      }
    }}
    onClick={() => {
      setShowTooltip(!showTooltip);
    }}
    className="p-1 md:p-2 hover:bg-blue-100 rounded-full transition-colors duration-200"
    aria-label="מידע נוסף על השוואה חכמה"
  >
    <HelpCircle className="h-4 w-4 md:h-5 md:w-5 text-blue-600 hover:text-blue-700" />
  </button>
  
  {lastUpdated && (
    <span className="text-xs md:text-base font-normal text-gray-600 mr-auto">
      הנתונים מעודכנים לחודש {lastUpdated}
    </span>
  )}
</h3>

{/* טולטיפ למובייל - מיד אחרי הכותרת */}
{isMobile && showTooltip && (
  <div className="mb-4 animate-in slide-in-from-top duration-300">
    <div className="relative bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4 border border-blue-200">
      <button
        onClick={() => {
          setShowTooltip(false);
        }}
        className="absolute top-2 right-2 text-gray-500 hover:text-red-500 transition-colors text-lg font-bold leading-none w-6 h-6 flex items-center justify-center rounded-full hover:bg-red-50"
        aria-label="סגור"
      >
        ×
      </button>
      
      <h4 className="font-semibold mb-3 text-blue-800 pr-8">
        📊 מה זה השוואה חכמה?
      </h4>
      
      <div className="space-y-3 text-gray-700">
        <p className="text-sm">
          השוואה מהירה וממוקדת בין שתי קופות / קרנות / פוליסות – בתשואה מצטברת, לכל תקופות ההשקעה מ-12 חודשים ועד 5 שנים.
        </p>
        
        <p className="text-sm">
          ניתוח ברור ומהיר של מי הובילה, מתי, ומהי עקביות הביצועים של כל קופה במסלול המקביל ברמת הסיכון.
        </p>
      </div>
    </div>
  </div>
)}

{/* טולטיפ לדקסטופ */}
{!isMobile && showTooltip && tooltipRef.current && (
  <TooltipPortal targetRef={tooltipRef}>
    <div className="bg-gray-900 text-white p-4 rounded-xl shadow-2xl max-w-sm border border-gray-600 text-sm leading-relaxed">
      <h4 className="font-semibold mb-3 text-white">
        📊 מה זה השוואה חכמה?
      </h4>
      
      <div className="space-y-3 text-gray-300">
        <p className="text-sm">
          השוואה מהירה וממוקדת בין שתי קופות / קרנות / פוליסות – בתשואה מצטברת, לכל תקופות ההשקעה מ-12 חודשים ועד 5 שנים.
        </p>
        
        <p className="text-sm">
          ניתוח ברור ומהיר של מי הובילה, מתי, ומהי עקביות הביצועים של כל קופה במסלול המקביל ברמת הסיכון.
        </p>
      </div>
      
      {/* חץ של הטולטיפ */}
      <div className="absolute top-full left-1/2 transform -translate-x-1/2">
        <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
      </div>
    </div>
  </TooltipPortal>
)}

{/* 🆕 Grid Layout - שתי קרנות לרוחב - תמיד! גם במובייל הכי קטן */}
<div className="grid grid-cols-2 gap-2 sm:gap-3 md:gap-4 mb-4 md:mb-6">
  
  {/* עמודה שמאלית - הקרן הנוכחית */}
  <div className="space-y-2 sm:space-y-3">
    <label className="block text-[10px] sm:text-xs md:text-sm font-bold text-gray-700 mb-1 md:mb-2">
      קרן נוכחית:
    </label>
    
    <div className="relative">
      <div className="space-y-2 sm:space-y-3">
        {/* מצב רשימה רגילה */}
        {!currentFundSearchMode && (
          <div className="relative">
            <select
              value={currentFundId}
              onChange={(e) => handleCurrentFundChange(e.target.value)}
              className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-blue-50"
            >
              {availableFunds.map(fund => (
                <option key={fund.id} value={fund.id}>
                  {getDisplayName(fund)} ({fund.id})
                  {parseInt(fund.id) === parseInt(currentProductId) ? ' ✓' : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* מצב חיפוש מתקדם */}
        {currentFundSearchMode && (
          <div className="relative">
            <input
              type="text"
              value={currentFundSearch}
              onChange={(e) => handleCurrentFundSearch(e.target.value)}
              placeholder="חיפוש..."
              className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-blue-50 pr-8"
            />
            <Search className="absolute left-2 top-1.5 sm:top-2.5 md:top-3.5 h-3 w-3 md:h-4 md:w-4 text-gray-400" />
            
            {/* תוצאות חיפוש */}
            {showCurrentFundResults && currentFundSearchResults.length > 0 && (
             <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-80 sm:max-h-96 md:max-h-[400px] overflow-y-auto">
                {currentFundSearchResults.map(fund => (
                  <div
                    key={fund.id}
                    onClick={() => selectCurrentFundFromSearch(fund)}
                    className="p-1.5 sm:p-2 md:p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                  >
                    <div className="flex justify-between items-start">
                      <div className="flex-1 min-w-0">
                        <p className="text-[10px] sm:text-xs md:text-sm font-bold text-gray-900 truncate">
                          {getDisplayName(fund)}
                        </p>
                        <p className="text-[9px] sm:text-xs text-gray-500">
                          {fund.company} | {fund.id}
                        </p>
                        <div className="flex items-center gap-1 mt-0.5">
                          <span className="text-[9px] sm:text-xs text-blue-600 font-bold">
                            סיכון: {fund.riskLevel?.level || '?'}
                          </span>
                          {fund.returns?.year1 && (
                            <span className="text-[9px] sm:text-xs text-green-600">
                              {fund.returns.year1.toFixed(1)}%
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* כפתורי החלפת מצב */}
        <div className="flex flex-col gap-1.5 sm:gap-2">
          {!currentFundSearchMode ? (
            <button
              onClick={toggleCurrentFundSearchMode}
              className="w-full px-1.5 sm:px-2 md:px-4 py-1.5 sm:py-2 md:py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg border-2 border-blue-600 hover:from-blue-600 hover:to-blue-700 transition-all duration-200 flex items-center justify-center gap-1 sm:gap-2 text-[10px] sm:text-xs md:text-sm font-bold shadow-md hover:shadow-lg"
            >
              <Search className="h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-4 md:w-4" />
              <span className="hidden lg:inline">חיפוש קרנות נוספות</span>
              <span className="lg:hidden">חיפוש</span>
            </button>
          ) : (
            <div className="flex flex-col gap-1.5 sm:gap-2">
              <button
                onClick={toggleCurrentFundSearchMode}
                className="w-full px-1.5 sm:px-2 md:px-4 py-1.5 sm:py-2 md:py-2.5 bg-gray-600 text-white rounded-lg border-2 border-gray-600 hover:bg-gray-700 transition-all duration-200 flex items-center gap-1 sm:gap-2 justify-center text-[10px] sm:text-xs md:text-sm font-bold shadow-md"
              >
                <svg className="h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-4 md:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
                רשימה
              </button>
              
              <div className="px-1.5 sm:px-2 md:px-3 py-1 sm:py-1.5 md:py-2.5 bg-blue-100 text-blue-800 rounded-lg flex items-center gap-1 sm:gap-2 justify-center text-[9px] sm:text-xs md:text-sm font-bold border border-blue-200">
                <Search className="h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-4 md:w-4" />
                חיפוש פעיל
              </div>
            </div>
          )}
        </div>

        {/* הודעה על קרן מחיפוש */}
        {currentFundData && !availableFunds.some(fund => fund.id === currentFundData.id) && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-1.5 sm:p-2">
            <p className="text-[9px] sm:text-xs text-green-700 flex items-center gap-1">
              <Search className="h-2.5 w-2.5 sm:h-3 sm:w-3 flex-shrink-0" />
              <span className="font-bold">מחיפוש</span>
            </p>
          </div>
        )}
      </div>
    </div>

    {/* דמי ניהול של הקרן הנוכחית */}
    {currentFundData && (
      <div className="bg-blue-50 rounded-lg p-1.5 sm:p-2 md:p-4 border border-blue-200">
        <label className="block text-[9px] sm:text-xs md:text-sm font-bold text-blue-700 mb-1">
        דמי ניהול מצבירה (%):
        </label>
        <input
          type="number"
          step="0.01"
          min="0"
          max="5"
          value={currentFundFee}
          onChange={(e) => setCurrentFundFee(e.target.value)}
          placeholder="0.60"
          className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-blue-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        
        {/* דמי ניהול מהפקדה לקרנות פנסיה */}
        {isPensionFund() && (
          <div className="mt-1.5 sm:mt-2 md:mt-3">
            <label className="block text-[9px] sm:text-xs md:text-sm font-bold text-blue-700 mb-1">
              דמי ניהול  מההפקדה (%):
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              max="5"
              value={currentFundDepositFee}
              onChange={(e) => setCurrentFundDepositFee(e.target.value)}
              placeholder="0.50"
              className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-blue-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        )}
      </div>
    )}
  </div>

  {/* עמודה ימנית - הקרן להשוואה */}
  <div className="space-y-2 sm:space-y-3">
    <label className="block text-[10px] sm:text-xs md:text-sm font-bold text-gray-700 mb-1 md:mb-2">
      קרן להשוואה:
    </label>
    
    <div className="relative">
      <div className="space-y-2 sm:space-y-3">
        {/* מצב רשימה רגילה */}
        {!selectedFundSearchMode && (
          <div className="relative">
            <select
              value={selectedFundId}
              onChange={(e) => {
                setSelectedFundId(e.target.value);
                handleFundSelection(e.target.value);
              }}
              className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-purple-50"
            >
              <option value="">בחר קרן...</option>
              {availableFunds
                .filter(fund => parseInt(fund.id) !== parseInt(currentFundId))
                .map(fund => (
                  <option key={fund.id} value={fund.id}>
                    {getDisplayName(fund)} ({fund.id})
                  </option>
                ))}
            </select>
          </div>
        )}

        {/* מצב חיפוש מתקדם */}
        {selectedFundSearchMode && (
          <div className="relative">
            <input
              type="text"
              value={selectedFundSearch}
              onChange={(e) => handleSelectedFundSearch(e.target.value)}
              placeholder="חיפוש..."
              className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-purple-50 pr-8"
            />
            <Search className="absolute left-2 top-1.5 sm:top-2.5 md:top-3.5 h-3 w-3 md:h-4 md:w-4 text-gray-400" />
            
            {/* תוצאות חיפוש */}
            {showSelectedFundResults && selectedFundSearchResults.length > 0 && (
           <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-80 sm:max-h-96 md:max-h-[400px] overflow-y-auto">
                {selectedFundSearchResults.map(fund => (
                  <div
                    key={fund.id}
                    onClick={() => selectSelectedFundFromSearch(fund)}
                    className="p-1.5 sm:p-2 md:p-3 hover:bg-purple-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                  >
                    <div className="flex justify-between items-start">
                      <div className="flex-1 min-w-0">
                        <p className="text-[10px] sm:text-xs md:text-sm font-bold text-gray-900 truncate">
                          {getDisplayName(fund)}
                        </p>
                        <p className="text-[9px] sm:text-xs text-gray-500">
                          {fund.company} | {fund.id}
                        </p>
                        <div className="flex items-center gap-1 mt-0.5">
                          <span className="text-[9px] sm:text-xs text-purple-600 font-bold">
                            סיכון: {fund.riskLevel?.level || '?'}
                          </span>
                          {fund.returns?.year1 && (
                            <span className="text-[9px] sm:text-xs text-green-600">
                              {fund.returns.year1.toFixed(1)}%
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* כפתורי החלפת מצב */}
        <div className="flex flex-col gap-1.5 sm:gap-2">
          {!selectedFundSearchMode ? (
            <button
              onClick={toggleSelectedFundSearchMode}
              className="w-full px-1.5 sm:px-2 md:px-4 py-1.5 sm:py-2 md:py-2.5 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg border-2 border-purple-600 hover:from-purple-600 hover:to-purple-700 transition-all duration-200 flex items-center justify-center gap-1 sm:gap-2 text-[10px] sm:text-xs md:text-sm font-bold shadow-md hover:shadow-lg"
            >
              <Search className="h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-4 md:w-4" />
              <span className="hidden lg:inline">חיפוש קרנות נוספות</span>
              <span className="lg:hidden">חיפוש</span>
            </button>
          ) : (
            <div className="flex flex-col gap-1.5 sm:gap-2">
              <button
                onClick={toggleSelectedFundSearchMode}
                className="w-full px-1.5 sm:px-2 md:px-4 py-1.5 sm:py-2 md:py-2.5 bg-gray-600 text-white rounded-lg border-2 border-gray-600 hover:bg-gray-700 transition-all duration-200 flex items-center gap-1 sm:gap-2 justify-center text-[10px] sm:text-xs md:text-sm font-bold shadow-md"
              >
                <svg className="h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-4 md:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
                רשימה
              </button>
              
              <div className="px-1.5 sm:px-2 md:px-3 py-1 sm:py-1.5 md:py-2.5 bg-purple-100 text-purple-800 rounded-lg flex items-center gap-1 sm:gap-2 justify-center text-[9px] sm:text-xs md:text-sm font-bold border border-purple-200">
                <Search className="h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-4 md:w-4" />
                חיפוש פעיל
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    {/* דמי ניהול של הקרן להשוואה */}
    {selectedFund && (
      <div className="bg-purple-50 rounded-lg p-1.5 sm:p-2 md:p-4 border border-purple-200">
        <label className="block text-[9px] sm:text-xs md:text-sm font-bold text-purple-700 mb-1">
         דמי ניהול מצבירה (%):
        </label>
        <input
          type="number"
          step="0.01"
          min="0"
          max="5"
          value={selectedFundFee}
          onChange={(e) => setSelectedFundFee(e.target.value)}
          placeholder="0.65"
          className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-purple-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        />
        
        {/* דמי ניהול מהפקדה לקרנות פנסיה */}
        {isPensionFund() && (
          <div className="mt-1.5 sm:mt-2 md:mt-3">
            <label className="block text-[9px] sm:text-xs md:text-sm font-bold text-purple-700 mb-1">
              דמי ניהול מההפקדה (%):
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              max="5"
              value={selectedFundDepositFee}
              onChange={(e) => setSelectedFundDepositFee(e.target.value)}
              placeholder="0.55"
              className="w-full p-1.5 sm:p-2 md:p-3 text-[10px] sm:text-xs md:text-base border border-purple-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            />
          </div>
        )}
      </div>
    )}
  </div>

</div>

{/* כפתור החלף קרנות - במרכז בין שתי העמודות */}
<div className="flex justify-center items-center my-2 md:my-3 gap-1.5 sm:gap-2 md:gap-3">
  <button
    onClick={handleSwapFunds}
    disabled={!selectedFundId || loading}
    className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white p-1 sm:p-1.5 md:p-3 rounded-full shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed group"
    title="החלף בין הקרנות"
  >
    <div className="flex items-center justify-center">
      <svg 
        className="h-3 w-3 sm:h-4 sm:w-4 md:h-6 md:w-6 transform group-hover:rotate-180 transition-transform duration-300" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
      </svg>
    </div>
  </button>
  <span className="text-[10px] sm:text-xs md:text-base text-gray-600 font-bold">החלף</span>
</div>
{/* כפתור ניתוח AI */}
{selectedFund && !loading && (
 <div className="mt-4 md:mt-6">
   <button
     onClick={handleSmartAnalysis}
     disabled={analyzingAI}
     className="group relative w-full overflow-hidden bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 hover:from-pink-600 hover:via-purple-600 hover:to-blue-600 text-white font-bold py-3 md:py-4 px-4 md:px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 disabled:opacity-50 disabled:transform-none disabled:shadow-lg"
   >
     {/* רקע זוהר */}
     <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 rounded-xl blur opacity-30 group-hover:opacity-50 animate-pulse -z-10 group-disabled:opacity-20"></div>
     
     {/* תוכן הכפתור */}
     <div className="relative flex items-center justify-center gap-2 md:gap-3">
       {analyzingAI ? (
         <>
           <Loader2 className="h-4 w-4 md:h-5 md:w-5 animate-spin" />
           <span className="text-sm md:text-base font-extrabold">מנתח בעזרת AI...</span>
         </>
       ) : (
         <>
           <Cpu className="h-4 w-4 md:h-5 md:w-5 animate-bounce group-hover:animate-spin transition-all duration-300" />
           <span className="text-sm md:text-base bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent font-extrabold">
             השוואה חכמה בעזרת AI
           </span>
         </>
       )}
     </div>
   </button>
 </div>
)}

{/* שאר הקוד נשאר זהה... */}
{/* אנימציית AI */}
{analyzingAI && <AdvancedAIAnimation />}

      
{smartAnalysis && (
  <div ref={analysisRef} className="mt-6 md:mt-8 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg md:rounded-xl p-4 md:p-6 border border-purple-200">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-3 md:mb-4 gap-2 sm:gap-0 ai-analysis-title">
            <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                <h4 className="text-sm md:text-lg font-bold text-purple-800 flex items-center gap-1 md:gap-2">
                    <Bot className="h-4 w-4 md:h-6 md:w-6" />
      ניתוח AI
    </h4>
    <p className="text-xs md:text-sm text-gray-600 mt-1 sm:mt-0">
      השוואת הביצועים בין שתי הקופות
    </p>
  </div>
  
  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-1 md:gap-2 w-full sm:w-auto">
    {copyMessage && (
      <span className="text-xs md:text-sm text-green-600 font-bold text-center sm:text-right">
        {copyMessage}
      </span>
    )}
    <button
  onClick={exportAll3PagesAsImages}
  disabled={!currentFundId || !selectedFund?.id || loading}
  className="flex items-center justify-center sm:justify-start gap-1 px-2 md:px-3 py-2 sm:py-1 bg-blue-600 text-white rounded-md md:rounded-lg hover:bg-blue-700 transition-colors text-xs md:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
  title="הורד 3 דפי תמונה"
>
  <svg 
    className="h-3 w-3 md:h-4 md:w-4" 
    fill="none" 
    stroke="currentColor" 
    viewBox="0 0 24 24"
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth={2} 
      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
    />
  </svg>
  <span className="hidden sm:inline">הורד תמונה</span>
  <span className="sm:inline md:hidden">תמונה</span>
</button>
    <button
      onClick={exportAll3PagesAsPDF}
      disabled={!currentFundId || !selectedFund?.id || loading || !smartAnalysis}
      className="flex items-center justify-center sm:justify-start gap-1 px-2 md:px-3 py-2 sm:py-1 bg-red-600 text-white rounded-md md:rounded-lg hover:bg-red-700 transition-colors text-xs md:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
      title="הורד PDF - 2 עמודים"
    >
      <svg 
        className="h-3 w-3 md:h-4 md:w-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" 
        />
      </svg>
      <span className="hidden sm:inline">הורד PDF</span>
      <span className="sm:inline md:hidden">PDF</span>
    </button>
    <button
      onClick={copySmartAnalysis}
      className="flex items-center justify-center sm:justify-start gap-1 px-2 md:px-3 py-2 sm:py-1 bg-purple-600 text-white rounded-md md:rounded-lg hover:bg-purple-700 transition-colors text-xs md:text-sm"
    >
      <Copy className="h-3 w-3 md:h-4 md:w-4" />
      העתק ניתוח מלא
    </button>
    <button
      onClick={handleShare}
      className="flex items-center justify-center sm:justify-start gap-1 px-2 md:px-3 py-2 sm:py-1 bg-green-600 text-white rounded-md md:rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm"
    >
      <Share2 className="h-3 w-3 md:h-4 md:w-4" />
      שתף ניתוח
    </button>
  </div>
</div>

          <div className="mb-4 md:mb-6 text-center">
            <div className="bg-gradient-to-r from-green-50 via-white to-green-50 rounded-xl p-4 md:p-6 border-2 border-green-200 shadow-lg">
              
           {/* אזור התוצאה הראשי - מותאם מובייל */}
<div className="bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 rounded-lg p-3 sm:p-4 md:p-6 text-white shadow-inner mb-4">
  <div className="flex items-center justify-between">
    
    {/* קבוצה ביתית (קרן נוכחית) */}
    <div className="flex-1 text-center min-w-0">
      <div className="text-xs sm:text-sm md:text-base font-bold text-blue-100 mb-1 sm:mb-2 px-1 sm:px-2">
        <div className="leading-tight break-words hyphens-auto" style={{ wordBreak: 'break-word' }}>
          {smartAnalysis.currentFundName}
        </div>
      </div>
      <div className="text-xl sm:text-2xl md:text-4xl font-black text-blue-300">
        {smartAnalysis.currentFundWins}
      </div>
    </div>

    {/* מפריד התוצאה */}
    <div className="flex flex-col items-center px-2 sm:px-3 md:px-6 flex-shrink-0">
      <div className="text-lg sm:text-xl md:text-3xl font-black text-white mb-0.5 sm:mb-1">-</div>
      <div className="text-xs text-gray-300">VS</div>
      <div className="w-4 sm:w-6 h-0.5 bg-white/30 mt-0.5 sm:mt-1"></div>
    </div>

    {/* קבוצה אורחת (קרן להשוואה) */}
    <div className="flex-1 text-center min-w-0">
      <div className="text-xs sm:text-sm md:text-base font-bold text-red-100 mb-1 sm:mb-2 px-1 sm:px-2">
        <div className="leading-tight break-words hyphens-auto" style={{ wordBreak: 'break-word' }}>
          {smartAnalysis.selectedFundName}
        </div>
      </div>
      <div className="text-xl sm:text-2xl md:text-4xl font-black text-red-300">
        {smartAnalysis.selectedFundWins}
      </div>
    </div>

  </div>
</div>

            </div>
          </div>

          <div className="mb-4 md:mb-6">
            <h5 className="text-sm md:text-xl font-bold text-purple-900 leading-tight">
              {(() => {
                const { actualWinner, currentFundWins, selectedFundWins, totalPeriods } = smartAnalysis;
                
                if (actualWinner === 'current') {
                  return `${smartAnalysis.currentFundName} מנצחת את ${smartAnalysis.selectedFundName} ב-${currentFundWins} מתוך ${totalPeriods} מדדי תקופות השוואה`;
                } else if (actualWinner === 'selected') {
                  return `${smartAnalysis.selectedFundName} מנצחת את ${smartAnalysis.currentFundName} ב-${selectedFundWins} מתוך ${totalPeriods} מדדי תקופות השוואה`;
                } else {
            return `בהשוואה של ${totalPeriods} תקופות השוואה כל גוף הציג עדיפות בתקופות שונות - ללא הכרעה ברורה`;
                }
              })()}
            </h5>
          </div>

          {(() => {
            const { actualWinner } = smartAnalysis;
            
            // 🔥 לוגיקה מתוקנת - תמיד מראה יתרונות וחסרונות של הקרן המנצחת
            if (actualWinner === 'current') {
              // הקרן הנוכחית מנצחת - נראה את היתרונות והחסרונות שלה
              return (
                <>
                  {smartAnalysis.performanceComparison.filter(p => p.currentWins).length > 0 && (
                    <div className="mb-4 md:mb-6">
                      <h6 className="font-bold text-green-800 mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base">
                        <img src="/advantaeg.png" alt="יתרון" className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                        יתרונות ב{smartAnalysis.currentFundName} (המנצחת):
                      </h6>
                      <p className="text-xs md:text-sm text-green-700 mb-2 md:mb-3">
                        ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:
                      </p>
                      <div className="space-y-2 md:space-y-3">
                        {smartAnalysis.performanceComparison
                          .filter(p => p.currentWins)
                          .map((period, index) => (
                            <div key={index} className="bg-green-50 p-2 md:p-3 rounded-md md:rounded-lg border border-green-200">
                              <div className="text-xs md:text-sm">
                                <span className="font-bold">תשואה מצטברת {period.period}:</span>{' '}
                                <span className="text-green-700 font-bold">{period.currentReturn}%</span> ב{smartAnalysis.currentFundName}{' '}
                                לעומת <span className="text-red-600 font-bold">{period.selectedReturn}%</span> ב{smartAnalysis.selectedFundName}
                                    {/* 🆕 הוספת ממוצע שנתי אם קיים */}
                          {(() => {
                                  const getAnnualAverage = (fundData, periodKey) => {
                                    switch(periodKey) {
                                      case 'year2': return fundData.returns?.avgAnnual2Years;
                                      case 'year3': return fundData.returns?.avgAnnual3Years;
                                      case 'year4': return fundData.returns?.avgAnnual4Years;
                                      case 'year5': return fundData.returns?.avgAnnual5Years;
                                      default: return null;
                                    }
                                  };
                                  
                                  const getMonthsFromPeriod = (periodKey) => {
                                    switch(periodKey) {
                                      case 'year2': return 24;
                                      case 'year3': return 36;
                                      case 'year4': return 48;
                                      case 'year5': return 60;
                                      default: return null;
                                    }
                                  };
                                  
                                  const currentAvg = getAnnualAverage(currentFundData, period.key);
                                  const selectedAvg = getAnnualAverage(selectedFund, period.key);
                                  const months = getMonthsFromPeriod(period.key);
                                  
                                  if (currentAvg !== null && selectedAvg !== null && months !== null) {
                                    return (
                                      <div className="text-xs text-gray-600 mt-1 italic">
                                        תשואה ממוצעת לכל שנה  ב-{months} חודשים: {currentAvg.toFixed(2)}% ב{smartAnalysis.currentFundName} | {selectedAvg.toFixed(2)}% ב{smartAnalysis.selectedFundName}
                                      </div>
                                    );
                                  }
                                  return null;
                                })()}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}

                  {smartAnalysis.performanceComparison.filter(p => !p.currentWins).length > 0 && (
                    <div className="mb-4 md:mb-6">
                      <h6 className="font-bold text-red-800 mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base">
                        <img src="/disadvanteg.png" alt="חיסרון" className="h-4 w-4 md:h-5 md:w-5" />
                        {smartAnalysis.performanceComparison.filter(p => !p.currentWins).length === 1 ? 'חיסרון' : 'חסרונות'} ב{smartAnalysis.currentFundName} (המנצחת):
                      </h6>
                      <p className="text-xs md:text-sm text-red-700 mb-2 md:mb-3">
                        ביצועים נמוכים יותר בתשואה שנתית נומינלית ברוטו:
                      </p>
                      <div className="space-y-2 md:space-y-3">
                        {smartAnalysis.performanceComparison
                          .filter(p => !p.currentWins)
                          .map((period, index) => (
                            <div key={index} className="bg-red-50 p-2 md:p-3 rounded-md md:rounded-lg border border-red-200">
                              <div className="text-xs md:text-sm">
                                <span className="font-bold">תשואה מצטברת {period.period}:</span>{' '}
                                <span className="text-red-600 font-bold">{period.currentReturn}%</span> ב{smartAnalysis.currentFundName}{' '}
                                לעומת <span className="text-green-700 font-bold">{period.selectedReturn}%</span> ב{smartAnalysis.selectedFundName}
                                {(() => {
  const getAnnualAverage = (fundData, periodKey) => {
    switch(periodKey) {
      case 'year2': return fundData.returns?.avgAnnual2Years;
      case 'year3': return fundData.returns?.avgAnnual3Years;
      case 'year4': return fundData.returns?.avgAnnual4Years;
      case 'year5': return fundData.returns?.avgAnnual5Years;
      default: return null;
    }
  };
  
  const currentAvg = getAnnualAverage(currentFundData, period.key);
  const selectedAvg = getAnnualAverage(selectedFund, period.key);
  
  if (currentAvg !== null && selectedAvg !== null) {
    return (
      <div className="text-xs text-gray-600 mt-1 italic">
        תשואה ממוצעת לכל שנה ב{period.years * 12} החודשים האחרונים: {currentAvg.toFixed(2)}% ב{smartAnalysis.currentFundName} | {selectedAvg.toFixed(2)}% ב{smartAnalysis.selectedFundName}
      </div>
    );
  }
  return null;
})()}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </>
              );
            } else if (actualWinner === 'selected') {
              // הקרן הנבחרת מנצחת - נראה את היתרונות והחסרונות שלה
              return (
                <>
                  {smartAnalysis.performanceComparison.filter(p => !p.currentWins).length > 0 && (
                    <div className="mb-4 md:mb-6">
                      <h6 className="font-bold text-green-800 mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base">
                        <img src="/advantaeg.png" alt="יתרון" className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                        יתרונות ב{smartAnalysis.selectedFundName} (המנצחת):
                      </h6>
                      <p className="text-xs md:text-sm text-green-700 mb-2 md:mb-3">
                        ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:
                      </p>
                      <div className="space-y-2 md:space-y-3">
                        {smartAnalysis.performanceComparison
                          .filter(p => !p.currentWins)
                          .map((period, index) => (
                            <div key={index} className="bg-green-50 p-2 md:p-3 rounded-md md:rounded-lg border border-green-200">
                              <div className="text-xs md:text-sm">
                                <span className="font-bold">תשואה מצטברת {period.period}:</span>{' '}
                                <span className="text-green-700 font-bold">{period.selectedReturn}%</span> ב{smartAnalysis.selectedFundName}{' '}
                                לעומת <span className="text-red-600 font-bold">{period.currentReturn}%</span> ב{smartAnalysis.currentFundName}
                                {(period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) && (
  <div className="text-xs text-gray-600 mt-1 italic">
    תשואה ממוצעת לכל שנה ב{period.years * 12} החודשים האחרונים: {period.selectedAnnualAvg.toFixed(2)}% ב{smartAnalysis.selectedFundName} | {period.currentAnnualAvg.toFixed(2)}% ב{smartAnalysis.currentFundName}
  </div>
)}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}

                  {smartAnalysis.performanceComparison.filter(p => p.currentWins).length > 0 && (
                    <div className="mb-4 md:mb-6">
                      <h6 className="font-bold text-red-800 mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base">
                        <img src="/disadvanteg.png" alt="חיסרון" className="h-4 w-4 md:h-5 md:w-5" />
                        {smartAnalysis.performanceComparison.filter(p => p.currentWins).length === 1 ? 'חיסרון' : 'חסרונות'} ב{smartAnalysis.selectedFundName} (המנצחת):
                      </h6>
                      <p className="text-xs md:text-sm text-red-700 mb-2 md:mb-3">
                        ביצועים נמוכים יותר בתשואה שנתית נומינלית ברוטו:
                      </p>
                      <div className="space-y-2 md:space-y-3">
                        {smartAnalysis.performanceComparison
                          .filter(p => p.currentWins)
                          .map((period, index) => (
                            <div key={index} className="bg-red-50 p-2 md:p-3 rounded-md md:rounded-lg border border-red-200">
                              <div className="text-xs md:text-sm">
                                <span className="font-bold">תשואה מצטברת {period.period}:</span>{' '}
                                <span className="text-red-600 font-bold">{period.selectedReturn}%</span> ב{smartAnalysis.selectedFundName}{' '}
                                לעומת <span className="text-green-700 font-bold">{period.currentReturn}%</span> ב{smartAnalysis.currentFundName}
                                {(period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) && (
  <div className="text-xs text-gray-600 mt-1 italic">
    תשואה ממוצעת לכל שנה ב{period.years * 12} החודשים האחרונים: {period.selectedAnnualAvg.toFixed(2)}% ב{smartAnalysis.selectedFundName} | {period.currentAnnualAvg.toFixed(2)}% ב{smartAnalysis.currentFundName}
  </div>
)}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </>
              );
            } else {
              // במקרה של תיקו - נראה יתרונות של כל קרן
              return (
                <>
                  {smartAnalysis.performanceComparison.filter(p => p.currentWins).length > 0 && (
                    <div className="mb-4 md:mb-6">
                      <h6 className="font-bold text-green-800 mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base">
                        <img src="/advantaeg.png" alt="יתרון" className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                        יתרונות ב{smartAnalysis.currentFundName}:
                      </h6>
                      <p className="text-xs md:text-sm text-green-700 mb-2 md:mb-3">
                        ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:
                      </p>
                      <div className="space-y-2 md:space-y-3">
                        {smartAnalysis.performanceComparison
                          .filter(p => p.currentWins)
                          .map((period, index) => (
                            <div key={index} className="bg-green-50 p-2 md:p-3 rounded-md md:rounded-lg border border-green-200">
                              <div className="text-xs md:text-sm">
                                <span className="font-bold">תשואה מצטברת {period.period}:</span>{' '}
                                <span className="text-green-700 font-bold">{period.currentReturn}%</span> ב{smartAnalysis.currentFundName}{' '}
                                לעומת <span className="text-red-600 font-bold">{period.selectedReturn}%</span> ב{smartAnalysis.selectedFundName}
                                {(period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) && (
                                  <div className="text-xs text-gray-600 mt-1 italic">
                                   תשואה ממוצעת לכל שנה ב{period.years * 12} החודשים האחרונים: <span className="text-green-600 font-bold">{period.currentAnnualAvg.toFixed(2)}%</span> ב{smartAnalysis.currentFundName} | <span className="text-red-500 font-bold">{period.selectedAnnualAvg.toFixed(2)}%</span> ב{smartAnalysis.selectedFundName}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}

                  {smartAnalysis.performanceComparison.filter(p => !p.currentWins).length > 0 && (
                    <div className="mb-4 md:mb-6">
                      <h6 className="font-bold text-green-800 mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base">
                        <img src="/advantaeg.png" alt="יתרון" className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                        יתרונות ב{smartAnalysis.selectedFundName}:
                      </h6>
                      <p className="text-xs md:text-sm text-green-700 mb-2 md:mb-3">
                        ביצועים גבוהים יותר בתשואה שנתית נומינלית ברוטו:
                      </p>
                      <div className="space-y-2 md:space-y-3">
                        {smartAnalysis.performanceComparison
                          .filter(p => !p.currentWins)
                          .map((period, index) => (
                            <div key={index} className="bg-green-50 p-2 md:p-3 rounded-md md:rounded-lg border border-green-200">
                              <div className="text-xs md:text-sm">
                                <span className="font-bold">תשואה מצטברת {period.period}:</span>{' '}
                                <span className="text-green-700 font-bold">{period.selectedReturn}%</span> ב{smartAnalysis.selectedFundName}{' '}
                                לעומת <span className="text-red-600 font-bold">{period.currentReturn}%</span> ב{smartAnalysis.currentFundName}
                                {(period.currentAnnualAvg !== null && period.selectedAnnualAvg !== null) && (
  <div className="text-xs text-gray-600 mt-1 italic">
    תשואה ממוצעת לכל שנה ב{period.years * 12} החודשים האחרונים: {period.selectedAnnualAvg.toFixed(2)}% ב{smartAnalysis.selectedFundName} | {period.currentAnnualAvg.toFixed(2)}% ב{smartAnalysis.currentFundName}
  </div>
)}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </>
              );
            }
          })()}
<div className="mb-4 md:mb-6">
            <h6 className={`font-bold mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base ${
              !smartAnalysis.feeComparison ? 'text-blue-800' :
              smartAnalysis.feeComparison.isEqual ? 'text-blue-800' :
              (() => {
                const { actualWinner } = smartAnalysis;
                
                if (actualWinner === 'tie') {
                  return 'text-green-800';
                }
                
                const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                const feeWinnerName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                const performanceWinnerHasFeeAdvantage = performanceWinnerName === feeWinnerName;
                
                return performanceWinnerHasFeeAdvantage ? 'text-green-800' : 'text-red-800';
              })()
            }`}>
              {!smartAnalysis.feeComparison ? 'דמי ניהול:' :
               smartAnalysis.feeComparison.isEqual ? 'דמי ניהול זהים:' :
               (() => {
                 const { actualWinner } = smartAnalysis;
                 
                 if (actualWinner === 'tie') {
                   const feeWinnerName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                   return (
                     <div className="flex items-center gap-1">
                       <img src="/advantaeg.png" alt="יתרון" className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                       <span>יתרון בדמי ניהול ל{feeWinnerName}:</span>
                     </div>
                   );
                 }
                 
                 const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                 const feeWinnerName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                 const performanceWinnerHasFeeAdvantage = performanceWinnerName === feeWinnerName;
                 
                 return (
                   <div className="flex items-center gap-1">
                     <img src={performanceWinnerHasFeeAdvantage ? "/advantaeg.png" : "/disadvanteg.png"} 
                          alt={performanceWinnerHasFeeAdvantage ? "יתרון" : "חיסרון"} 
                          className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                     <span>
                       {performanceWinnerHasFeeAdvantage ? 
                         `יתרון נוסף ב${performanceWinnerName} (המנצחת):` : 
                         `חיסרון ב${performanceWinnerName} (המנצחת):`}
                     </span>
                   </div>
                 );
               })()}
            </h6>
            
            <div className={`p-2 md:p-3 rounded-md md:rounded-lg border text-xs md:text-sm ${
              !smartAnalysis.feeComparison ? 'bg-blue-50 border-blue-200' :
              smartAnalysis.feeComparison.isEqual ? 'bg-blue-50 border-blue-200' :
              (() => {
                const { actualWinner } = smartAnalysis;
                
                if (actualWinner === 'tie') {
                  return 'bg-green-50 border-green-200';
                }
                
                const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                const feeWinnerName = smartAnalysis.feeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                const performanceWinnerHasFeeAdvantage = performanceWinnerName === feeWinnerName;
                
                return performanceWinnerHasFeeAdvantage ? 
                  'bg-green-50 border-green-200' : 'bg-red-50 border-red-200';
              })()
            }`}>
              {!smartAnalysis.feeComparison ? (
                <p>לא הוזנו דמי ניהול לשתי הקרנות</p>
              ) : smartAnalysis.feeComparison.isEqual ? (
                <p>דמי ניהול מהחיסכון זהים בשתי הקרנות - {smartAnalysis.feeComparison.currentFee}%</p>
              ) : smartAnalysis.feeComparison.currentHasAdvantage ? (
                <p>דמי ניהול מהחיסכון נמוכים יותר: {smartAnalysis.feeComparison.currentFee}% ב{smartAnalysis.currentFundName} לעומת {smartAnalysis.feeComparison.selectedFee}% ב{smartAnalysis.selectedFundName}</p>
              ) : (
                <p>דמי ניהול מהחיסכון גבוהים יותר: {smartAnalysis.feeComparison.currentFee}% ב{smartAnalysis.currentFundName} לעומת {smartAnalysis.feeComparison.selectedFee}% ב{smartAnalysis.selectedFundName}</p>
              )}
            </div>
          </div>
{isPensionFund() && (
            <div className="mb-4 md:mb-6">
              <h6 className={`font-bold mb-2 md:mb-3 flex items-center gap-1 md:gap-2 text-xs md:text-base ${
                !smartAnalysis.depositFeeComparison ? 'text-blue-800' :
                smartAnalysis.depositFeeComparison.isEqual ? 'text-blue-800' :
                (() => {
                  const { actualWinner } = smartAnalysis;
                  
                  if (actualWinner === 'tie') {
                    return 'text-green-800';
                  }
                  
                  const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                  const depositFeeWinnerName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                  const performanceWinnerHasDepositFeeAdvantage = performanceWinnerName === depositFeeWinnerName;
                  
                  return performanceWinnerHasDepositFeeAdvantage ? 'text-green-800' : 'text-red-800';
                })()
              }`}>
                {!smartAnalysis.depositFeeComparison ? 'דמי ניהול מהפקדה:' :
                 smartAnalysis.depositFeeComparison.isEqual ? 'דמי ניהול מהפקדה זהים:' :
                 (() => {
                   const { actualWinner } = smartAnalysis;
                   
                   if (actualWinner === 'tie') {
                     const depositFeeWinnerName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                     return (
                       <div className="flex items-center gap-1">
                         <img src="/advantaeg.png" alt="יתרון" className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                         <span>יתרון בדמי ניהול מהפקדה ל{depositFeeWinnerName}:</span>
                       </div>
                     );
                   }
                   
                   const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                   const depositFeeWinnerName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                   const performanceWinnerHasDepositFeeAdvantage = performanceWinnerName === depositFeeWinnerName;
                   
                   return (
                     <div className="flex items-center gap-1">
                       <img src={performanceWinnerHasDepositFeeAdvantage ? "/advantaeg.png" : "/disadvanteg.png"} 
                            alt={performanceWinnerHasDepositFeeAdvantage ? "יתרון" : "חיסרון"} 
                            className="h-4 w-4 md:h-5 md:w-5 animate-zoom-pulse" />
                       <span>
                         {performanceWinnerHasDepositFeeAdvantage ? 
                           `יתרון נוסף בדמי ניהול מהפקדה ב${performanceWinnerName}:` : 
                           `חיסרון בדמי ניהול מהפקדה ב${performanceWinnerName}:`}
                       </span>
                     </div>
                   );
                 })()}
              </h6>
              
              <div className={`p-2 md:p-3 rounded-md md:rounded-lg border text-xs md:text-sm ${
                !smartAnalysis.depositFeeComparison ? 'bg-blue-50 border-blue-200' :
                smartAnalysis.depositFeeComparison.isEqual ? 'bg-blue-50 border-blue-200' :
                (() => {
                  const { actualWinner } = smartAnalysis;
                  
                  if (actualWinner === 'tie') {
                    return 'bg-green-50 border-green-200';
                  }
                  
                  const performanceWinnerName = actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                  const depositFeeWinnerName = smartAnalysis.depositFeeComparison.currentHasAdvantage ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                  const performanceWinnerHasDepositFeeAdvantage = performanceWinnerName === depositFeeWinnerName;
                  
                  return performanceWinnerHasDepositFeeAdvantage ? 
                    'bg-green-50 border-green-200' : 'bg-red-50 border-red-200';
                })()
              }`}>
                {!smartAnalysis.depositFeeComparison ? (
                  <p>לא הוזנו דמי ניהול מהפקדה לשתי הקרנות</p>
                ) : smartAnalysis.depositFeeComparison.isEqual ? (
                  <p>דמי ניהול מהפקדה זהים בשתי הקרנות - {smartAnalysis.depositFeeComparison.currentDepositFee}%</p>
                ) : smartAnalysis.depositFeeComparison.currentHasAdvantage ? (
                  <p>דמי ניהול מהפקדה נמוכים יותר: {smartAnalysis.depositFeeComparison.currentDepositFee}% ב{smartAnalysis.currentFundName} לעומת {smartAnalysis.depositFeeComparison.selectedDepositFee}% ב{smartAnalysis.selectedFundName}</p>
                ) : (
                  <p>דמי ניהול מהפקדה גבוהים יותר: {smartAnalysis.depositFeeComparison.currentDepositFee}% ב{smartAnalysis.currentFundName} לעומת {smartAnalysis.depositFeeComparison.selectedDepositFee}% ב{smartAnalysis.selectedFundName}</p>
                )}
              </div>
            </div>
          )}
          {/* גילוי נאות ותוצאה סופית */}
          <div className="mt-6 md:mt-8 bg-white p-4 md:p-6 rounded-xl border border-gray-200">
            <div className="mb-4">
              <h6 className="text-lg font-bold text-gray-900 mb-3">גילוי נאות</h6>
              <div className="text-sm md:text-base text-gray-800 leading-relaxed space-y-3">
                {smartAnalysis.recommendation.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
            
            <div className="border-t pt-4">
              <h6 className="text-lg font-bold text-orange-600 mb-3 flex items-center gap-2">
                🐂 הטיפ של השור מגמל AI:
              </h6>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                עם כמה שבינה מלאכותית זה פלא הבריאה 🌎 עדיין, לפני קבלת החלטה אמיתית על הכסף שלך – עדיף להתייעץ עם בעל רישיון מוסמך 🧑‍🎓 ואנושי 🧬 הפועל תחת רגולציה של משרד האוצר 🛡️
              </p>
              
              {/* כפתורי העתקה ושיתוף */}
              <div className="flex justify-start mt-4">
                <div className="flex items-center gap-2">
                  {(copyMessage || shareMessage) && (
                    <span className="text-xs md:text-sm text-green-600 font-bold">
                      {copyMessage || shareMessage}
                    </span>
                  )}
                  <button
                    onClick={copySmartAnalysis}
                    className="flex items-center gap-2 px-3 md:px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm md:text-base shadow-md hover:shadow-lg"
                  >
                    <Copy className="h-4 w-4 md:h-5 md:w-5" />
                    העתק ניתוח מלא
                  </button>
                  <div className="relative">
                    <button
                      onClick={handleShare}
                      className="flex items-center gap-2 px-3 md:px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm md:text-base shadow-md hover:shadow-lg"
                    >
                      <Share2 className="h-4 w-4 md:h-5 md:w-5" />
                      שתף ניתוח
                    </button>
                    
                    {/* תפריט אפשרויות שיתוף */}
                    {showShareOptions && (
                      <div className="absolute top-full left-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-50 min-w-[180px]">
                        <button
                          onClick={handleWhatsAppShare}
                          className="flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-700 hover:bg-green-50 rounded-md transition-colors"
                        >
                          <MessageCircle className="h-4 w-4 text-green-600" />
                          שתף בוואטסאפ
                        </button>
                        <button
                          onClick={handleEmailShare}
                          className="flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-700 hover:bg-blue-50 rounded-md transition-colors"
                        >
                          <Mail className="h-4 w-4 text-blue-600" />
                          שתף באימייל
                        </button>
                        <button
                          onClick={handleCopyForShare}
                          className="flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
                        >
                          <Copy className="h-4 w-4 text-gray-600" />
                          העתק לשיתוף
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* קישורים לפעולות */}
        <div className="next-steps-section bg-gradient-to-r from-blue-50 to-purple-50 p-4 rounded-lg border border-blue-200 mt-4">
  <h6 className="text-base font-bold text-blue-800 mb-3">מה הלאה?</h6>
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() => {
                      const winnerFund = smartAnalysis.actualWinner === 'current' ? currentFundData : selectedFund;
                      const winnerName = smartAnalysis.actualWinner === 'current' ? smartAnalysis.currentFundName : smartAnalysis.selectedFundName;
                      
                      handleOpenLeadModal({
                        source: 'comparison-result',
                        category: category,
                        winnerFund: winnerFund,
                        winnerName: winnerName
                      });
                    }}
                    className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-bold"
                  >
                    💬 רוצה לקבל הסבר על התוצאות?
                  </button>
                  

                </div>
              </div>
            </div>

            <p className="text-xs md:text-sm text-gray-500 mt-4 pt-4 border-t">
              📊 מקור: כל הזכויות שמורות לגמלנט AI – ניתוח השוואה חכם בין מוצרי השקעה פנסיוניים ופיננסיים.<br/>
              תאריך נכונות הנתונים: {lastUpdated}
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-4">
  <p className="text-xs text-yellow-800 leading-relaxed">
    ⚠️ <strong>דיסקליימר:</strong> המידע המוצג באתר הינו כללי ואינפורמטיבי בלבד. אין לראות בו ייעוץ השקעות, שיווק השקעות, חוות דעת מקצועית או המלצה. השימוש בתוכן האתר נעשה באחריות המשתמש בלבד.{' '}
    <a href="/legal-disclaimer" target="_blank" className="text-yellow-700 hover:text-yellow-900 underline">
      ראו דיסקליימר המלא
    </a>
  </p>
</div>
          </div>
        </div>
      )}

      {/* LeadModal */}
<LeadModal 
  isOpen={showLeadModal}
  onClose={() => {
    // console.log('🔍 onClose triggered');
    setShowLeadModal(false);
  }}
  onSubmit={() => setShowLeadModal(false)}
  sourceContext={leadModalContext}
/>
    </div>
  );
};

export default FundComparisonComponent;